//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { PermisionsFolderService } from 'src/app/Services/Global/Permissions/permisions-folder.service';
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';
import { GeneralCDMSService } from 'src/app/Services/Global/GeneralCDMS/general-cdms.service';
import { LlamaIndexService } from 'src/app/Services/LlamaIndex/llama-index.service';

//-================ IMPORTS FOR CONSTANTS ================-\\
import { Icon_Image } from 'src/app/Constants/Constants-Global/Images-Icon';
import { Key_Header } from 'src/app/Constants/Constants-CCP/Key_Header';
import { URLs } from 'src/environments/constants';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import { saveAs } from 'file-saver';
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Group_Notification } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Group_Notification.interface';
import { Create_WorkFlow, Task } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Create-WF.interface';
import { Data_Inv, FILE_CCP, FILE_CCP_PROPERTIES } from 'src/app/Interfaces/Libraries/Library-CCP-Int/File_CCP.interface';
import { File_Same_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Same-File-CCP.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Update_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Update-CCP.interface';
import { FILE_CAP } from 'src/app/Interfaces/Libraries/Library-FIN-int/FileCAP.interface';
import { Icon_Images } from 'src/app/Interfaces/Interfaces-Global/Icon_Images.interface';
import { User_CDMS } from 'src/app/Interfaces/Interfaces-Global/User_CDMS.interface';
import { Filter_Check_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Filter_Check_CCP.interface';
import { TASK_ALL_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/All-Task-CCP.interface';
import { Download_Log_CCP } from 'src/app/Constants/Backlog/CCP/Download_Log';
import { Permission, Permissions } from 'src/app/Constants/Admin/Permissions';
import { Response_CCP } from 'src/app/Interfaces/Interfaces-Global/Response.interface';
import { Task_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Task-CCP.interface';
import { Area_CCP, Shop_Area_CCP, Shop_Area_Noti_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Area_Shop.interface';
import { Groups_Approvers_CCP } from 'src/app/Interfaces/Interfaces-Global/Data_User_Group.interface';
import { Permission_Folder_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Permissions/Permission_CCP.interface';
import { permissionSystemFolderCCP, PermissionSystemFolderCCPType, tpermissionFolderCCP } from 'src/app/types/CCP/permissionFolderCCP.type';
import { GeneralRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { Table } from 'primeng/table';



@Component({
    selector: 'app-file-manager-lib-ccp',
    templateUrl: './file-manager-lib-ccp.component.html',
    styleUrls: ['./file-manager-lib-ccp.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/LibrayGlobal.css'],
    standalone: false
})
export class FileManagerLibCCPComponent implements OnInit {

  @ViewChild('dtCCP')
  dtCCP!: Table;

  @ViewChild('AddFileCCP')
  MyInputAddFile!: ElementRef;

  @ViewChild('UpdFileCCP')
  MyInputUpdFile!: ElementRef;


  //-===================================== SECTION FORMS =====================================-\\

  //+===================== FORM ADD NEW FOLDER =====================+\\
  public FormAddFolderCCP: FormGroup = new FormGroup({
    NameFolderCCP: new FormControl('', [Validators.required, Validators.pattern(/^[^\\/:*?"<>|]*$/)]),
    OCR_Regex: new FormControl('')
  })

  //+================== VARIABLES FOR MODAL FOLDER CONFIG ==================+\\
  public ShowAdvancedConfig: boolean = false;

  //+===================== FORM ADD NEW CCP =====================+\\
  public FormCCP: FormGroup = new FormGroup({
    NameCCP: new FormControl('', Validators.required),
    // KeyWord: new FormControl({ value: '', disabled: true }, Validators.required),
    Model_Year: new FormControl({ value: '', disabled: true }, [Validators.pattern(/\d/)]),
    Code_CCP: new FormControl({ value: '', disabled: true }, Validators.required),
    NoRevCCP: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.pattern(/(^([1-9]|[1-9][0-9]|[1-9][0-9][0-9])$)|(^[N]+$)/)]),
    Invoice_4M: new FormControl({ value: '', disabled: true }, Validators.required),
    Shop: new FormControl({ value: 0, disabled: true }, Validators.required),
    Area: new FormControl({ value: 0, disabled: true }, Validators.required),
    Reviwer: new FormControl({ value: '', disabled: true }, Validators.required),
    Approver: new FormControl({ value: '', disabled: true }, Validators.required),
  });

  //?======== GET VALUE NAMECCP ========?\\
  get NameFileCCP() {
    return this.FormCCP.controls['NameCCP'];
  }


  //+===================== FORM UPDATE CCP =====================+\\
  public FormCCPUpdate: FormGroup = new FormGroup({
    NameCCP: new FormControl('', Validators.required),
    // KeyWord: new FormControl({ value: '', disabled: true }, Validators.required),
    Model_Year: new FormControl({ value: '', disabled: true }, [Validators.pattern(/\d/)]),
    Code_CCP: new FormControl({ value: '', disabled: true }, Validators.required),
    NoRevCCP: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.pattern(/(^([1-9]|[1-9][0-9]|[1-9][0-9][0-9])$)|(^[N]+$)/)]),
    Invoice_4M: new FormControl({ value: '', disabled: true }, Validators.required),
    Shop: new FormControl({ value: 0, disabled: true }, Validators.required),
    Area: new FormControl({ value: 0, disabled: true }, Validators.required),
    Reviwer: new FormControl({ value: '', disabled: true }, Validators.required),
    Approver: new FormControl({ value: '', disabled: true }, Validators.required),
  });

  //?======== GET VALUE NAMECCP IN UPDATE ========?\\
  get NameFileCCPUpdate() {
    return this.FormCCPUpdate.controls['NameCCP'];
  }

  //+===================== FORM RENAME FILE OR DIRECTORY =====================+\\
  public FormRenameFD: FormGroup = new FormGroup({
    NameRename: new FormControl('', [Validators.required, Validators.pattern(`([^\\/:*?"<>|]*)`)])
  })

  //?======== GET VALUE NAMERENAME ========?\\
  get NameRename() {
    return this.FormRenameFD.controls['NameRename']
  }

  //+===================== FORM PROPERTIES =====================+\\
  public FormCCPProperties: FormGroup = new FormGroup({
    NameCCP: new FormControl('', [Validators.required, Validators.pattern(`([^\\/:*?"<>|]*)`)]),
    // KeyWord: new FormControl('', Validators.required),
    Model_Year: new FormControl('', [Validators.pattern(/\d/)]),
    Code_CCP: new FormControl('', Validators.required),
    NoRevCCP: new FormControl('', [Validators.required, Validators.pattern(/(^([1-9]|[1-9][0-9]|[1-9][0-9][0-9])$)|(^[N]+$)/)]),
    Invoice_4M: new FormControl('', Validators.required),
    Shop: new FormControl('', Validators.required),
    Area: new FormControl('', Validators.required),
    Reviwer: new FormControl('', Validators.required),
    Approver: new FormControl('', Validators.required),
  });

  //-========================= SECTION VARIABLES =========================-\\

  //+================== HEADERS ==================+\\
  public Key_Header_CCP = Key_Header;
  public Header_Routes: string[] = ['raiz'];
  public CCP_Table_Headers: Headers_CCP[] = [];


  //+================== FILTERS ==================+\\
  public CCP_Filter: string = '';


  //+================== VARIABLES FOR GLOBAL NAVIGATION ==================+\\
  public NumberTopL: number = 0;
  public ID_Folder_Level: number = 0;
  public Route_Level_Global: string = '';


  //+================== VARIABLES TOTALS ==================+\\
  public TotalFoldersC: number = 0;
  public TotalFilesCCP: number = 0;

  // --- LÓGICA DE VISTA PREVIA ---
  public showPreview: boolean = false;
  public previewFileName: string = '';
  public previewFileUrl: string = '';
  public previewFileExtension: string = '';


  //+================== VARIABLES FOR USERS REVIWERS ==================+\\
  public ListOfUsersReviewers: User_CDMS[] = [];
  public ListOfUsersApprovers: User_CDMS[] = [];


  //+================== VARIABLES FOR LOAD PAGE ==================+\\
  public LoadPage: boolean = false;


  //+================== VARIABLES FILES ==================+\\
  public FileAuxAddCCP: FILE_CAP = { FileData: null, FileName: '' };
  public FileAuxUpdCCP: FILE_CAP = { FileData: null, FileName: '' };


  //+================== VARIABLES CREDENTIALS ==================+\\
  private ID_User_BD: number = 0;


  //+================== VARIABLE PERMISION ==================+\\
  public Permission_FMC: tpermissionFolderCCP[] = [];
  public PermissionCCP: PermissionSystemFolderCCPType = permissionSystemFolderCCP;

  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;

  //+================== VARIABLES GLOBAL FILES CCP ==================+\\
  private All_Task_CCP: number = 0;
  public All_FAF_CCP: FILE_CCP[] = [];
  public SelectedALL_FAF_CCP!: FILE_CCP[];
  public FCCP_Select_CM: FILE_CCP = {
    ID: 0,
    Extension: '',
    Name: '',
    Key_Word: '',
    Revision_No: '',
    Model_Year: 0,
    Code: '',
    Invoice_4M: '',
    Status: 0,
    ID_Folder: 0,
    Shop: 0,
    Area: 0,
    ID_Involved_User_Approver: 0,
    ID_Involved_User_Reviewer: 0,
    Approver_Name: '',
    Reviewer_Name: '',
    Date_Created: null,
    Date_Expiration: null,
    ID_Contributor: 0,
    Contributor_Name: '',
    ID_Previous_Version: null,
    ID_Next_Version: null,
    Status_System: 0,
    Directory: false,
    Path: '',
  }

  public FILE_CCP_Properties: FILE_CCP_PROPERTIES = {
    ID: 0,
    Extension: '',
    Name: '',
    Key_Word: '',
    Revision_No: '',
    Model_Year: 0,
    Code: '',
    Invoice_4M: '',
    Status: 0,
    Area: 0,
    Shop: 0,
    ID_Folder: 0,
    TaskReviewer: {
      ID: 0,
      ID_Involved_User: 0,
      ID_UR: 0,
      Status: 0,
    },
    TaskApprover: {
      ID: 0,
      ID_Involved_User: 0,
      ID_UR: 0,
      Status: 0,
    },
    Date_Created: null,
    Date_Expiration: null,
    Date_End: null,
    ID_Contributor: '',
    Directory: false,
    Reviewer_Name: '',
    Approver_Name: '',
    Contributor_Name: '',
    Path: '',
  }


  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  public ColorConfirm: string = '#20a8e1';
  public ColorsCancel: string = '#fc6161';


  //+================== VARIABLES FOR ARCHIVES DUPLICATED ==================+\\
  public FilesCCP_Dup: File_Same_CCP[] = [];


  //+================== VARIABLES FOR KEY SNAPSHOTS ==================+\\
  public KeySnap: string = 'em';


  //+================== VARIABLES FOR EXP REG ==================+\\
  public expression: RegExp = /[0-9Â]+§/
  public expression2: RegExp = /[/,]+/

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_CCP = {
    Extension: [],
    Model_Year: [],
    Status: [],
    Reviewer_Name: [],
    Approver_Name: [],
    Contributor_Name: [],
  };

  //+============== SIDEBAR FLAG =================+\\
  public Right_Sidebar_Visible: boolean = false;

  //+================== VARIABLES FOR ICONS IMAGE ==================+\\
  public Icons_Image: Icon_Images[] = Icon_Image;

  //+===================== FORM REASON REJECT =====================+\\
  public FormReject: FormGroup = new FormGroup({
    ReasonText: new FormControl('', [Validators.required, Validators.minLength(5)])
  })

  //+===================== OCR TOGGLES =====================+\\
  public UseOCR_Local: boolean = true;
  public UseOCR_Cloud: boolean = false;

  public ToggleOCR_Local(): void {
    this.UseOCR_Local = !this.UseOCR_Local;
    if (this.UseOCR_Local) {
      this.UseOCR_Cloud = false;
    }
  }

  public ToggleOCR_Cloud(): void {
    this.UseOCR_Cloud = !this.UseOCR_Cloud;
    if (this.UseOCR_Cloud) {
      this.UseOCR_Local = false;
    }
  }

  //-========================= SECTION ARRAY FILL =========================-\\
  //+================== MODEL YEAR ==================+\\
  public OptionsModelYear = [
    { value: 2021, item: '2021' },
    { value: 2022, item: '2022' },
    { value: 2023, item: '2023' },
    { value: 2024, item: '2024' },
  ]

  //+================== SHOP CCP ==================+\\
  public Shops: Shop_Area_Noti_CCP[] = [];

  public ShopSelected!: Shop_Area_Noti_CCP;

  public UserService = inject(UserDataService);
  public llamaService = inject(LlamaIndexService);

  constructor(public Service_CCP: LIBRARYCCPService, public PermissionFolder: PermisionsFolderService, public ServiceGeneralCDMS: GeneralCDMSService, public router: Router, public ActivatedRouter: ActivatedRoute) {
    this.ID_User_BD = Number(localStorage.getItem('ID_U_DB'));
    this.KeySnap = this.ActivatedRouter.snapshot.params['Key'];
  }

  ngOnInit(): void {
    this.Load_component();
  }

  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  //-================== FUNCTTION FOR LOAD COMPONENT ==================-\\
  private async Load_component(): Promise<void> {
    this.Load_HeadersCCP_Table();
    this.Load_Users();
    await this.Load_Task();
    this.Load_Shop_Area_CCP();

    if (this.KeySnap != 'em') {

      const RouteDecode: string = decodeURIComponent(this.KeySnap);
      const Folder: string = RouteDecode.split('/').pop() || '';
      const ID_Folder: number = Number(Folder.split('§').shift());


      const ArrayRoute: string[] = RouteDecode.split('/');
      for (const Item of ArrayRoute) { this.Header_Routes.push(Item); this.NumberTopL += 1; }

      this.Route_Level_Global = RouteDecode;

      if (!isNaN(ID_Folder)) {

        this.CheckUserPermissionFolder(ID_Folder, RouteDecode);

      } else {
        Swal.fire({
          title: 'Ocurrió un error',
          text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })
      }
    } else {

      this.SeeFolder_BreadCrum(0);
    }
  }

  //-================== FUNCTTION FOR LOAD HEADERS CCP ==================-\\
  private Load_HeadersCCP_Table(): void {

    this.Service_CCP.GetHeaders().subscribe((res: any) => {

      if (res.success) {

        const HeadersRes = res.operation;

        HeadersRes.forEach((element: any) => {
          this.CCP_Table_Headers.push({ Key_Header: element.Key_Header, ID: element.ID, Name: element.Name, Position: element.Position, Visible: element.Visible });
        });
      } else {
        Swal.fire(
          'Ocurrió un error',
          '¡Notifique este error al supervisor!',
          'warning'
        )
      }

    })
  }

  //-================== FUNCTTION FOR LOAD USERS APPROVERS AND REVIWERS ==================-\\
  private async Load_Users(): Promise<void> {

    try {

      const ResApprovers: Response_CCP = await firstValueFrom(this.Service_CCP.Get_Reviewers_Approvers_Groups_CCP());

      if (ResApprovers.success) {
        const All_Users_Groups: Groups_Approvers_CCP = ResApprovers.operation;
        this.ListOfUsersReviewers = All_Users_Groups.G_Approvers_1;
        this.ListOfUsersApprovers = All_Users_Groups.G_Approvers_2;

      }


    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error Usuarios',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }




  }

  //-================== FUNCTTION FOR LOAD TASKS ==================-\\
  private async Load_Task(): Promise<void> {

    try {

      const ResTask: any = await firstValueFrom(this.Service_CCP.GetTaskOfUser({ ID_Involved_User: this.ID_User_BD, Status: 1, IsConsultViewTask: false }))

      if (ResTask.success) {

        const Tasks: TASK_ALL_CCP[] = ResTask.operation;

        this.All_Task_CCP = Tasks.length;

      }

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Obtener Tareas)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //-================== FUNCTTION FOR LOAD SHOPS AND AREA ==================-\\
  private async Load_Shop_Area_CCP(): Promise<void> {

    try {

      const ResShop_Area: Response_CCP = await firstValueFrom(this.Service_CCP.Get_Shop_Area_CCP());

      this.Shops = ResShop_Area.operation;


    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error (Shop Areas)',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

    }

  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR NAVIGATION IN FOLDERS =====================&\\

  //-================== FUNCTTION FOR FOLDER NAVITATION ==================-\\
  public SeeFolder(CCP_Folder: FILE_CCP): void {
    this.NumberTopL += 1;

    const RouteLevel: string = CCP_Folder.Path;
    this.Route_Level_Global = RouteLevel;

    const ID_Folder: number = CCP_Folder.ID;

    const LastFolder: string = CCP_Folder.Path.split('/').pop() || '';

    if (!isNaN(ID_Folder)) {

      this.Header_Routes.push(LastFolder);

      this.CheckUserPermissionFolder(ID_Folder, RouteLevel);

    } else {
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //-================== FUNCTTION FOR BACK NAVIGATION FOLDER ==================-\\
  public GoBackFolder(): void {

    this.NumberTopL -= 1;
    this.Header_Routes.pop();

    let CurrentRoute: string = this.Route_Level_Global;
    let RoutePop: string[] = CurrentRoute.split('/');
    RoutePop.pop();

    const RouteLevel: string = RoutePop.join('/');
    this.Route_Level_Global = RouteLevel;

    const LastFolder: string = RouteLevel.split('/').pop() || '';
    const ID_Folder: number = Number(LastFolder.split('§').shift());



    if (!isNaN(ID_Folder)) {

      this.CheckUserPermissionFolder(ID_Folder, RouteLevel);

    } else {
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //-================== FUNCTTION FOR NAVIGATION FOR ROUTE ==================-\\
  public SeeFolder_BreadCrum(Position: number): void {


    const DifferenceNum: number = this.NumberTopL - Position;

    this.NumberTopL = Position;

    let CurrentRoute: string = this.Route_Level_Global;
    let RoutePop: string[] = CurrentRoute.split('/');

    for (let i = 0; i < DifferenceNum; i++) {
      RoutePop.pop();
      this.Header_Routes.pop();
    }

    const RouteLevel: string = RoutePop.join('/');
    this.Route_Level_Global = RouteLevel;

    const LastFolder: string = RouteLevel.split('/').pop() || '';
    const ID_Folder: number = Number(LastFolder.split('§').shift());

    if (!isNaN(ID_Folder)) {

      this.CheckUserPermissionFolder(ID_Folder, RouteLevel);

    } else {
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //-================== FUNCTTION FOR CLEAN FILTER TABLE ==================-\\
  private cleanFilterTable(): void {
    this.CCP_Filter = '';
    if (this.dtCCP)
      this.dtCCP.filterGlobal(this.CCP_Filter, 'contains');
  }

  //-================== FUNCTTION FOR CHECK PERMISIONS IN FOLDER ==================-\\
  private async CheckUserPermissionFolder(ID_Folder: number, Route: string): Promise<void> {
    this.LoadPage = false;

    const Permission_Folder: Permission_Folder_CCP = await this.PermissionFolder.GetPermissionsInFolderCCP(this.ID_User_BD, ID_Folder);

    this.Permission_FMC = Permission_Folder.Permission

    console.log(this.Permission_FMC);

    this.ID_Folder_Level = ID_Folder;

    this.GetInformationDiretory(Route);

  }

  //&===================== END FUNCTIONS FOR NAVIGATION IN FOLDERS =====================&\\




  //&===================== FUNCTIONS FOR ADD NEW FOLDER CCP =====================&\\

  //-================== FUNCTTION FOR MODAL ADD FOLDER CCP ==================-\\
  public ToggleModalAddFolderCCP(CloseOrOpen: boolean): void {
    if (!CloseOrOpen) {
      this.FormAddFolderCCP.reset({
        OCR_Regex: ''
      });
      this.ShowAdvancedConfig = false;
    }
    const ModalAddFolderCCP = document.getElementById('ModalAddFolderCCP') as HTMLElement;
    CloseOrOpen ? ModalAddFolderCCP.classList.add('active') : ModalAddFolderCCP.classList.remove('active');
  }

  //-================== FUNCTTION FOR VALIDATIONS AND CREATE FOLDER CCP ==================-\\
  public AddFolder(): void {

    const NameFolder: string = this.FormAddFolderCCP.controls['NameFolderCCP'].value.trim();

    const IsExistinPath: boolean = this.Check_Folder_in_Path(NameFolder);

    if (IsExistinPath) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: `No puede nombrar la carpeta con este nombre `,
        text: `¡La carpeta ya existe en este directorio!`,
        confirmButtonColor: this.ColorConfirm
      })
    } else if (this.FormAddFolderCCP.valid) {
      Swal.fire({
        title: '¿El nombre de carpeta es correcto?',
        text: "Si todo esta bien, presiona el botón para continuar",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, Crear carpeta',
        cancelButtonText: 'No, Cancelar',
      }).then(async (result) => {

        if (result.isConfirmed) {

          const reqPayload = { 
            Path: this.Route_Level_Global, 
            Name: NameFolder,
            OCR_Regex: this.FormAddFolderCCP.value.OCR_Regex
          };
          const ResCreatedFolder: any = await firstValueFrom(this.Service_CCP.CreateFolder(reqPayload));


          if (ResCreatedFolder.success) {
            Swal.fire({
              icon: 'success',
              title: 'Carpeta creada correctamente',
              confirmButtonColor: this.ColorConfirm
            })
            this.SeeFolder_BreadCrum(this.NumberTopL);
            this.ToggleModalAddFolderCCP(false);
          } else {
            Swal.fire({
              title: 'Ocurrió un error',
              text: '¡Ocurrió un error a crear una carpeta, si el problema persiste notifique a supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })
            this.SeeFolder_BreadCrum(this.NumberTopL);
            this.ToggleModalAddFolderCCP(false);
          }

        }
      })

    } else {
      Swal.fire({
        title: '¡Nombre no valido!',
        text: `No se permiten los siguientes caracteres \\ / : * ? " < > |`,
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  //-================== FUNCTTION FOR CHECK IF EXISIT FOLDER IN ROUTE ==================-\\
  private Check_Folder_in_Path(NameFolder: string): boolean {

    let Exist: boolean = false;

    this.All_FAF_CCP.map((item: FILE_CCP) => {
      if (item.Name === NameFolder) {
        Exist = true;
      }
    })

    return Exist;
  }

  //&===================== END FUNCTIONS FOR ADD NEW FOLDER CCP =====================&\\




  //&===================== FUNCTIONS FOR ADD NEW CCP =====================&\\

  //-================== FUNCTTION FOR OPEN OR CLOSE MODAL ADD CCP ==================-\\
  public ToggleModalAddCCP(CloseOrOpen: boolean): void {
    this.ResetFormCCP();
    const ModalAddCCP = document.getElementById('ModalAddCCP') as HTMLDivElement;
    CloseOrOpen ? ModalAddCCP.classList.add('active') : ModalAddCCP.classList.remove('active');
  }

  //-================== FUNCTTION FOR RESET FORM CCP AND FILEAUX ==================-\\
  private ResetFormCCP(): void {
    this.FormCCP.reset();
    this.FileAuxAddCCP = {
      FileData: null,
      FileName: ''
    }
    this.MyInputAddFile.nativeElement.value = null;
  }

  //-================== FUNCTTION FOR CHECK IF EXISIT CCP IN PATH ==================-\\
  private Check_CCP_in_Path(NameFile: string): boolean {

    let Exist: boolean = false;

    this.All_FAF_CCP.map((item: FILE_CCP) => {
      if (item.Name === NameFile) {
        Exist = true;
      }
    })

    return Exist;
  }

  //-================== FUNCTTION FOR SWET ALERT ==================-\\
  private See_ModalExist(): void {
    Swal.fire({
      position: 'center',
      icon: 'warning',
      title: 'No puede guardar la HOE ',
      text: '¡La HOE ya existe en este directorio!',
      confirmButtonColor: this.ColorConfirm
    }).then((results) => {
      if (results.isConfirmed) {
        this.ToggleModalAddCCP(false);
      }
    })
  }

  //-================== FUNCTTION FOR ADD FILE CCP ==================-\\
  public async AddDocument(data: Event): Promise<void> {
    const Target = data.target as HTMLInputElement;
    let file: File = (Target.files as FileList)[0];

    if (file) {
      this.FileAuxAddCCP = {
        FileData: file,
        FileName: file.name
      }

      this.FormCCP.controls['NameCCP'].setValue(file.name);
      const Band = this.Check_CCP_in_Path(file.name);

      if (await this.checkFileIsEncrypted()) {
        this.Invalid_FileEncrypt(false);
        return;
      }

      if (Band) { this.See_ModalExist() } else {
        this.Is_See_Files_Same_Name(file.name);
      }

    } else {
      this.Invalid_FileEncrypt(false);
    }
  }

  private async checkFileIsEncrypted(): Promise<boolean> {
    try {

      const File_FormData = new FormData();
      File_FormData.append('File', this.FileAuxAddCCP.FileData, this.FileAuxAddCCP.FileName);

      const resVerifyFile: Response_CCP = await firstValueFrom(this.Service_CCP.Upload_CheckFileEncrypt(File_FormData));
      return resVerifyFile.operation;

    } catch (error) {

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'No se pudo verificar este archivo',
        text: '¡intente cargar nuevamente el archivo, si el problema persiste notifique a su supervisor!',
        confirmButtonColor: this.ColorConfirm
      });
      this.Invalid_FileEncrypt(true);
      return false;
    }
  }

  private Invalid_FileEncrypt(error: boolean): void {
    if (!error) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Archivo protegido con contraseña',
        text: '¡No es posible cargar archivos que estén protegidos con contraseña!',
        confirmButtonColor: this.ColorConfirm
      });
    }

    this.FileAuxAddCCP = {
      FileData: null,
      FileName: ''
    }
    this.FormCCP.controls['NameCCP'].setValue('');
  }

  //-================== FUNCTTION FOR CUT NAME ==================-\\
  public CutNameFile(Name: string): string {

    if (Name !== undefined) {
      if (Name.length > 20) {
        const Ext = Name.split('.').pop();
        const NameCut = Name.slice(0, 25);
        return NameCut + '....' + Ext;
      } else {
        return Name;
      }

    } else {
      return '';
    }
  }

  //-================== FUNCTTION FOR SAVE NEW CCP ==================-\\
  public SavedNewCCP(): void {

    const Id_Groups: number[] = this.Check_Notification();

    const IsValidForm: boolean = this.IsValidFormCCP();

    if (this.FormCCP.valid && IsValidForm) {

      if (Id_Groups.length === 0) {
        Swal.fire({
          title: 'Sin notificación a grupos',
          text: "¡No ha seleccionado ningún grupo para notificación, ¿desea continuar sin notificaciones?!",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, continuar',
          cancelButtonText: 'No, Cancelar',
        }).then((results => {
          if (results.isConfirmed) {
            this.SendNewCCP(Id_Groups);
          }
        }))

      } else {

        Swal.fire({
          title: '¿Los grupos a notificar son correctos?',
          text: "Si todo esta bien, presiona el botón para continuar",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, son correctos',
          cancelButtonText: 'No, Cancelar',
        }).then((result => {
          if (result.isConfirmed) {
            this.SendNewCCP(Id_Groups);
          }
        }))
      }

    }
  }

  //-================== FUNCTTION FOR SEND NEW CCP ==================-\\
  private async SendNewCCP(Groups: number[]): Promise<void> {

    this.ToggleModalNotification(false);

    const UserReviewer: User_CDMS = this.FormCCP.controls['Reviwer'].value;
    const UserApprover: User_CDMS = this.FormCCP.controls['Approver'].value;

    const Tasks: Task[] = [{ ID_Involved_User: UserReviewer.ID, ID_UR: 1 }, { ID_Involved_User: UserApprover.ID, ID_UR: 2 }];

    const SC_Workflow: Create_WorkFlow = {
      ID_Contributor: this.ID_User_BD,
      ID_Previous_Version: null,
      ID_Next_Version: null,
      Name: this.FormCCP.controls['NameCCP'].value,
      Extension: this.FormCCP.controls['NameCCP'].value.split('.').pop(),
      // Key_Word: this.FormCCP.controls['KeyWord'].value,
      Model_Year: this.FormCCP.controls['Model_Year'].value || 0,
      Code: this.FormCCP.controls['Code_CCP'].value,
      Revision_No: this.FormCCP.controls['NoRevCCP'].value,
      Invoice_4M: this.FormCCP.controls['Invoice_4M'].value,
      ID_Folder: this.ID_Folder_Level,
      Shop: (this.FormCCP.controls['Shop'].value).ID,
      Area: (this.FormCCP.controls['Area'].value).ID,
      Current_Version: true,
      tasks: Tasks,
      Notification: Groups,
      route: encodeURIComponent(this.Route_Level_Global)
    };

    const fileCCP: File = this.FileAuxAddCCP.FileData;

    const Content_Progress = document.getElementById('Content-Progress') as HTMLDivElement;
    const Progress_Bar = document.getElementById('Progress-Bar') as HTMLDivElement;

    try {

      // Generar Markdown para OCR (Extracción de Folio RR/UCL)
      let markdownContent = '';
      if (fileCCP) {
        try {
          const selectedParser: 'lite' | 'llama' = this.UseOCR_Local ? 'lite' : 'llama';
          markdownContent = await this.llamaService.parseFileToMarkdown('lib-ccp', fileCCP, selectedParser);
          console.log(`[OCR CCP] Markdown generado correctamente (${markdownContent.length} caracteres)`);
          SC_Workflow.Markdown = markdownContent;
        } catch (error) {
          console.warn(`[OCR CCP] No se pudo generar el Markdown, continuando sin autodetectar folio:`, error);
        }
      }

      const Send_Icon = document.getElementById('Send-Icon') as HTMLElement;
      const Text_Btn = document.getElementById('Text-Btn') as HTMLSpanElement;


      this.OnDisabledAdd(true);

      Send_Icon.style.transform = `scale(0.5) translateX(-200px)`;
      Text_Btn.textContent = 'Enviando';
      Text_Btn.style.transform = `translateX(-10px)`;

      Content_Progress.classList.add('active')

      this.Service_CCP.CreateWorkflow(SC_Workflow, fileCCP).subscribe((event: any) => {

        if (event.status === 500) {

          this.OnDisabledAdd(false);
          Content_Progress.classList.remove('active')
          Progress_Bar.style.width = "0%";

          Swal.fire({
            title: 'Error en la HOE',
            text: '¡Ha ocurrido un error al cargar la HOE, informe al supervisor!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          })

          this.ToggleModalAddCCP(false);
          this.SeeFolder_BreadCrum(this.NumberTopL);

        }

        if (event['loaded'] && event['total']) {
          let value = (Math.round(event['loaded'] / event['total'] * 100));
          Progress_Bar.style.width = value + "%";
        }

        if (event['body']) {
          this.OnDisabledAdd(false);
          Content_Progress.classList.remove('active')
          Progress_Bar.style.width = "0%";

          this.AnimationBbuttonSave();
          this.SeeFolder_BreadCrum(this.NumberTopL);
        }
      })




    } catch (e) {

      Swal.fire({
        title: 'Error en la HOE',
        text: '¡No se guardo el archivo de la HOE en el sistema, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
      this.OnDisabledAdd(false);
      Content_Progress.classList.remove('active')
      Progress_Bar.style.width = "0%";
      this.ToggleModalAddCCP(false);
      this.SeeFolder_BreadCrum(this.NumberTopL);
    }

  }

  //-================== FUNCTION FOR DISABLED BUTTONS IN CCP FORM WHILE SENDING ==================-\\
  private OnDisabledAdd(IsDisabled: boolean): void {

    const Btn = document.getElementById('BtnSavedCCP') as HTMLButtonElement;
    const Btn_Close_Add_Top = document.getElementById('Btn-Close-Add-Top') as HTMLButtonElement;
    const Btn_Close_Add_Bottom = document.getElementById('Btn-Close-Add-Bottom') as HTMLButtonElement;

    if (IsDisabled) {
      Btn.disabled = true;
      Btn_Close_Add_Top.disabled = true;
      Btn_Close_Add_Bottom.disabled = true;
    } else {
      Btn.disabled = false;
      Btn_Close_Add_Top.disabled = false;
      Btn_Close_Add_Bottom.disabled = false;
    }

  }

  //-================== FUNCTION FOR TOOGLE NOTIFICATION GROUPS ==================-\\
  public ValidToogleCCP(): void {

    const IsValidForm: boolean = this.IsValidFormCCP();

    if (this.FormCCP.valid && IsValidForm) {
      this.Toggle_Modal_Sweet_Alert_SendCCP(true);
    }

  }

  public Toggle_Modal_Sweet_Alert_SendCCP(band: boolean): void {
    const modal = document.getElementById('Sweet_Alert') as HTMLDivElement;
    setTimeout(() => { band ? (modal.classList.add('active')) : (modal.classList.remove('active')) }, 100);
  }

  public Sweet_Alert_Send_New_CCP(): void {
    this.Toggle_Modal_Sweet_Alert_SendCCP(false);
    this.Validate_Open_Notification();
  }

  public Validate_Open_Notification(): void {

    const IsValidForm: boolean = this.IsValidFormCCP();

    if (this.FormCCP.valid && IsValidForm) {

      if (this.ShopSelected! && this.ShopSelected.ShopNotification.length > 0) {
        this.ToggleModalNotification(true);
      } else {
        Swal.fire({
          title: 'Notificación a grupos',
          text: "¡Aún no existen grupos para enviar notificación de la creación de una nueva HOE!",
          icon: 'question',
          confirmButtonColor: this.ColorConfirm,
        }).then((result2) => {
          if (result2.isConfirmed) {
            this.SendNewCCP([0]);
          }
        })
      }
    }

  }

  //-================== FUNCTION OPEN OR CLOSE MODAL FOR NOTIFICATION ==================-\\
  public ToggleModalNotification(band: boolean): void {

    const modal = document.getElementById('ModalNotificationCCP') as HTMLDivElement;

    band ? (modal.classList.add('active')) : (modal.classList.remove('active'))

  }

  //-================== FUNCTION TO CHECK IF NOTIFICATION GROUPS ARE SELECTED ==================-\\
  private Check_Notification(): number[] {

    let Id_Groups: number[] = [];

    for (let i = 0; i < this.ShopSelected.ShopNotification.length; i++) {
      const Group = this.ShopSelected.ShopNotification[i];
      const CheckBox = document.getElementById(`CheckBox${i}`) as HTMLInputElement;
      if (CheckBox.checked) {
        Id_Groups.push(Group.ID);
        CheckBox.checked = false;
      }
    }

    return Id_Groups;

  }

  //-================== FUNCTION TO CHECK THAT THE USERS ARE NOT REPLICATED IN THE FORM ==================-\\
  public UserIsReplicated(): boolean {

    const ValueReviwer = this.FormCCP.controls['Reviwer'].value;
    const ValueApprover = this.FormCCP.controls['Approver'].value;

    if (ValueReviwer === null || ValueReviwer === '' || this.NameFileCCP.invalid) return false;

    if (ValueApprover === null || ValueApprover === '' || this.NameFileCCP.invalid) return false;

    return ValueReviwer.ID === ValueApprover.ID;

  }

  //-================== FUNCTION IS VALID FORM ==================-\\
  private IsValidFormCCP(): boolean {


    const IdInputFileNewCCP = document.getElementById('IdInputFileNewCCP') as HTMLInputElement; IdInputFileNewCCP.classList.remove('Is-Invalid-Form');
    const IdInputKeyWNewCCP = document.getElementById('IdInputKeyWNewCCP') as HTMLInputElement;
    const IdInputSeleNewCCP = document.getElementById('IdInputSeleNewCCP') as HTMLElement;
    const IdinputShopNewCCP = document.getElementById('IdinputShopNewCCP') as HTMLElement;
    const IdinputAreaNewCCP = document.getElementById('IdinputAreaNewCCP') as HTMLElement;
    const IdInputAuReNewCCP = document.getElementById('IdInputAuReNewCCP') as HTMLElement;
    const IdInputAuApNewCCP = document.getElementById('IdInputAuApNewCCP') as HTMLElement;
    const IdinputInvoiceCCP = document.getElementById('IdinputInvoiceCCP') as HTMLInputElement;
    const IdInputCodeNewCCP = document.getElementById('IdInputCodeNewCCP') as HTMLInputElement;
    const IdNoRevOne1NewCCP = document.getElementById('IdNoRevOne1NewCCP') as HTMLInputElement;

    if (!this.FormCCP.controls['NameCCP'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Archivo no valido',
        text: '¡Ingrese un archivo HOE!',
        confirmButtonColor: this.ColorConfirm
      })
      IdInputFileNewCCP.classList.add('Is-Invalid-Form');
      return false;
    }

    // if (!this.FormCCP.controls['KeyWord'].valid) {
    //   Swal.fire({
    //     icon: 'warning',
    //     title: 'KeyWord no valida',
    //     text: '¡Ingrese una keyWord valida!',
    //     confirmButtonColor: this.ColorConfirm
    //   })
    //   IdInputKeyWNewCCP.classList.add('ng-invalid'); IdInputKeyWNewCCP.classList.add('ng-touched');
    //   return false;
    // }

    if (!this.FormCCP.controls['Model_Year'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Model Year no valido',
        text: '¡Seleccione un model year en la lista proporcionada!',
        confirmButtonColor: this.ColorConfirm
      })
      IdInputSeleNewCCP.classList.add('ng-invalid'); IdInputSeleNewCCP.classList.add('ng-touched');
      return false;
    }

    if (!this.FormCCP.controls['Shop'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'La Shop no es válida',
        text: '¡Por favor, asegúrese de seleccionar una Shop proporcionada por el sistema!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputShopNewCCP.classList.add('ng-invalid'); IdinputShopNewCCP.classList.add('ng-touched');
      return false;
    }

    if (!this.FormCCP.controls['Area'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'El Area no es válida',
        text: '¡Por favor, asegúrese de seleccionar una Area proporcionada por el sistema!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputAreaNewCCP.classList.add('ng-invalid'); IdinputAreaNewCCP.classList.add('ng-touched');
      return false;
    }

    if (!this.FormCCP.controls['Reviwer'].valid) {

      Swal.fire({
        icon: 'warning',
        title: 'Usuario revisor no valido',
        text: '¡No ha seleccionado a un revisor, por favor seleccione uno!',
        confirmButtonColor: this.ColorConfirm
      })

      IdInputAuReNewCCP.classList.add('ng-invalid'); IdInputAuReNewCCP.classList.add('ng-touched');
      return false;

    } else {

      const ValueReviwer: User_CDMS = this.FormCCP.controls['Reviwer'].value;

      if (ValueReviwer.ID === undefined) {
        Swal.fire({
          icon: 'warning',
          title: 'Usuario revisor no valido',
          text: '¡Seleccione un usuario revisor proporcionado por el sistema!',
          confirmButtonColor: this.ColorConfirm
        });

        IdInputAuReNewCCP.classList.add('ng-invalid'); IdInputAuReNewCCP.classList.add('ng-touched');
        return false;
      }

    }

    if (!this.FormCCP.controls['Approver'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Usuario aprobador no valido',
        text: '¡No ha seleccionado a un aprobador, por favor seleccione uno!',
        confirmButtonColor: this.ColorConfirm
      })

      IdInputAuApNewCCP.classList.add('ng-invalid'); IdInputAuApNewCCP.classList.add('ng-touched');
      return false;

    } else {

      const ValueApprover: User_CDMS = this.FormCCP.controls['Approver'].value;

      if (ValueApprover.ID === undefined) {
        Swal.fire({
          icon: 'warning',
          title: 'Usuario aprobador no valido',
          text: '¡Seleccione un usuario aprobador proporcionado por el sistema!',
          confirmButtonColor: this.ColorConfirm
        });

        IdInputAuApNewCCP.classList.add('ng-invalid'); IdInputAuApNewCCP.classList.add('ng-touched');
        return false;
      }

    }

    if (!this.FormCCP.controls['Invoice_4M'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Folio 4M no valido',
        text: '¡Ingrese un folio de 4M!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputInvoiceCCP.classList.add('ng-invalid'); IdinputInvoiceCCP.classList.add('ng-touched');
      return false;
    }

    if (!this.FormCCP.controls['Code_CCP'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Código no valido',
        text: '¡Ingrese un código de HOE!',
        confirmButtonColor: this.ColorConfirm
      })

      IdInputCodeNewCCP.classList.add('ng-invalid'); IdInputCodeNewCCP.classList.add('ng-touched');
      return false;
    }


    if (!this.FormCCP.controls['NoRevCCP'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'No. Revisión no valido',
        text: '¡ingrese un numero de revisión valido, número mayor a 0 o N!',
        confirmButtonColor: this.ColorConfirm
      })
      IdNoRevOne1NewCCP.classList.add('ng-invalid'); IdNoRevOne1NewCCP.classList.add('ng-touched');
      return false;

    }

    // const ValueReviwer: User_CDMS = this.FormCCP.controls['Reviwer'].value;
    // const ValueApprover: User_CDMS = this.FormCCP.controls['Approver'].value;

    // if (ValueReviwer.ID === ValueApprover.ID) {
    //   Swal.fire({
    //     icon: 'warning',
    //     title: 'Usuarios repetidos',
    //     text: '¡No puede repetir los usuarios en los campos, intente cambiar alguno usuario!',
    //     confirmButtonColor: this.ColorConfirm
    //   })
    //   IdInputAuReNewCCP.classList.add('ng-invalid'); IdInputAuReNewCCP.classList.add('ng-touched');
    //   IdInputAuApNewCCP.classList.add('ng-invalid'); IdInputAuApNewCCP.classList.add('ng-touched');
    //   return false;
    // }



    return true;
  }

  private AnimationBbuttonSave(): void {

    const Send_Icon = document.getElementById('Send-Icon') as HTMLElement;
    const Check_Icon = document.getElementById('Check-Icon') as HTMLElement;
    const Text_Btn = document.getElementById('Text-Btn') as HTMLSpanElement;
    const Btn = document.getElementById('BtnSavedCCP') as HTMLButtonElement;




    Text_Btn.style.transform = `translateY(80px)`;
    Text_Btn.classList.remove('loading')
    Send_Icon.style.transition = `1000ms ease 230ms`;
    Send_Icon.style.transform = `scale(2) translateX(120px)`;
    setTimeout(() => {
      Check_Icon.style.opacity = `1`;

      Text_Btn.classList.add('notransition');
      Text_Btn.style.transform = `translateY(0px)`;
      Text_Btn.textContent = 'Enviada';
      Text_Btn.offsetHeight;
      Text_Btn.classList.remove('notransition');

      Check_Icon.style.transform = `translate(-20px,0px)`;
      setTimeout(() => {
        this.ToggleModalAddCCP(false);
        Text_Btn.textContent = 'Enviar HOE';
        Check_Icon.style.opacity = `0`;
        Check_Icon.style.transform = 'translateY(-80px)';
        Send_Icon.style.transform = 'scale(1) translateX(0px)';
        Btn.disabled = false;
        Swal.fire({
          icon: 'success',
          title: 'HOE enviada a revisión',
          confirmButtonColor: this.ColorConfirm
        })
      }, 500);
    }, 1000);

  }

  //&===================== END FUNCTIONS FOR ADD NEW CCP =====================&\\




  //&===================== FUNCTIONS FOR UPDATE CCP =====================&\\

  //-================== FUNCTION TO VALIDATE IF A CCP CAN BE UPDATED ==================-\\
  public Can_Upgrade(CCP: FILE_CCP): void {


    if (CCP.Status !== 2) {
      this.FCCP_Select_CM = CCP;
      this.ResetFormUpdate();
      this.FillFormUpdate();
      this.ToggleModalUpdateCCP(true);

    } else {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: '¡HOE en revisión!',
        text: 'Esta HOE esta en un proceso de aprobación. Puedes descargar la última versión aprobada.',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: 'Ver ultima revisión <i class="fa fa-arrow-right"></i>',
      }).then((result: any) => {
        if (result.isConfirmed) {
          window.open(`${URLs.URLINDEX}/Dashboard/CCP/LatestAppCCP/${CCP.ID}`)
          // this.router.navigate(['/Dashboard/CCP/LatestAppCCP/', CCP.ID]);
        }
      })
    }
  }

  //-================== FUNCTION FOR ADD UPDATE FILE ==================-\\
  public async UpdateAddDocument(data: Event): Promise<void> {
    const Target = data.target as HTMLInputElement;
    const file: File = (Target.files as FileList)[0];

    if (file) {
      this.FileAuxUpdCCP = {
        FileData: file,
        FileName: file.name
      }

      if (await this.checkFileIsEncryptedUpdate()) {
        this.Invalid_FileEncrypt_Update(false);
        return;
      }

      this.FormCCPUpdate.controls['NameCCP'].setValue(file.name);
      this.Is_See_Files_Same_Name(file.name);

    } else {
      this.FileAuxUpdCCP = {
        FileData: null,
        FileName: ''
      }
      this.FormCCPUpdate.controls['NameCCP'].setValue('');
    }
  }

  private async checkFileIsEncryptedUpdate(): Promise<boolean> {
    try {

      const File_FormData = new FormData();
      File_FormData.append('File', this.FileAuxUpdCCP.FileData, this.FileAuxUpdCCP.FileName);

      const resVerifyFile: Response_CCP = await firstValueFrom(this.Service_CCP.Upload_CheckFileEncrypt(File_FormData));
      return resVerifyFile.operation;

    } catch (error) {

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'No se pudo verificar este archivo',
        text: '¡intente cargar nuevamente el archivo, si el problema persiste notifique a su supervisor!',
        confirmButtonColor: this.ColorConfirm
      });
      this.Invalid_FileEncrypt_Update(true);
      return true;
    }
  }

  private Invalid_FileEncrypt_Update(error: boolean): void {
    if (!error) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Archivo protegido con contraseña',
        text: '¡No es posible cargar archivos que estén protegidos con contraseña!',
        confirmButtonColor: this.ColorConfirm
      });
    }

    this.FileAuxUpdCCP = {
      FileData: null,
      FileName: ''
    }
    this.FormCCPUpdate.controls['NameCCP'].setValue('');
  }

  //-================== FUNCTION RESET FORM AND FILEAUX ==================-\\
  private ResetFormUpdate() {
    this.FormCCPUpdate.reset();
    this.FileAuxUpdCCP = {
      FileData: null,
      FileName: ''
    }
    this.MyInputUpdFile.nativeElement.value = null;
  }

  //-================== FUNCTION FOR OPEN OR CLOSE MODAL UPDATE OF CCP ==================-\\
  public ToggleModalUpdateCCP(CloseOrOpen: boolean): void {
    const ModalUpdateCCP = document.getElementById('ModalUpdateCCP') as HTMLElement;
    CloseOrOpen ? ModalUpdateCCP.classList.add('active') : ModalUpdateCCP.classList.remove('active');
  }

  //-================== FUNCTION FOR FILL FORM IN UPDATE CCP ==================-\\
  private FillFormUpdate(): void {

    let UserReviewer: User_CDMS = { ID: this.FCCP_Select_CM.ID_Involved_User_Reviewer, Name: this.FCCP_Select_CM.Reviewer_Name };
    let UserApprover: User_CDMS = { ID: this.FCCP_Select_CM.ID_Involved_User_Approver, Name: this.FCCP_Select_CM.Approver_Name };

    const FindShop: Shop_Area_CCP = this.Shops.find((item) => item.ID === this.FCCP_Select_CM.Shop) ?? { ID: 0, Name: '', Area: [] }
    const FindArea: Area_CCP = FindShop.Area.find((item) => item.ID === this.FCCP_Select_CM.Area) ?? { ID: 0, Name: '' }

    // this.FormCCPUpdate.controls['KeyWord'].setValue(this.FCCP_Select_CM.Key_Word);
    this.FormCCPUpdate.controls['Model_Year'].setValue(this.FCCP_Select_CM.Model_Year);
    this.FormCCPUpdate.controls['Code_CCP'].setValue(this.FCCP_Select_CM.Code);
    this.FormCCPUpdate.controls['NoRevCCP'].setValue(this.FCCP_Select_CM.Revision_No);
    this.FormCCPUpdate.controls['Invoice_4M'].setValue(this.FCCP_Select_CM.Invoice_4M);
    this.FormCCPUpdate.controls['Shop'].setValue(FindShop)
    this.FormCCPUpdate.controls['Area'].setValue(FindArea)
    this.FormCCPUpdate.controls['Reviwer'].setValue(UserReviewer);
    this.FormCCPUpdate.controls['Approver'].setValue(UserApprover);
  }

  //-================== FUNCTION TO KNOW OF EQUAL NAMES OF CCP ==================-\\
  private async Is_See_Files_Same_Name(NameFile: string): Promise<void> {

    try {
      const ResFilesSame: any = await firstValueFrom(this.Service_CCP.GetEqualNameCCPInSF({ NameFile: NameFile }));

      if (ResFilesSame.success) {
        if (ResFilesSame.operation.length > 0) {
          this.FilesCCP_Dup = ResFilesSame.operation;
          this.ToggleModalSameFilesCCP();
        }
      }

    } catch (e) {
      Swal.fire({
        title: 'Error',
        text: '¡Error al verificar si la HOE ya existe en este directorio, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  //-================== FUNCTION FOR OPEN OR CLOSE MODAL SAME FILES ==================-\\
  public ToggleModalSameFilesCCP(): void {
    let ModalSameFHCCP = document.getElementById('ModalSameFHCCP') as HTMLDivElement;
    let ModalSameFilesCCP = document.getElementById('ModalSameFilesCCP') as HTMLDivElement;

    ModalSameFHCCP.classList.toggle('active');
    ModalSameFilesCCP.classList.toggle('active');
  }

  //-================== FUNCTION FOR OPEN OR CLOSE MODAL NOTIFICATION TO GROUPS ==================-\\
  public ToggleModalNotificationUpdate(band: boolean): void {

    const modal = document.getElementById('ModalNotificationCCPUpdate') as HTMLDivElement;

    band ? (modal.classList.add('active')) : (modal.classList.remove('active'))

  }

  //-================== FUNCTION TO CHECK THAT THE USERS ARE NOT REPLICATED IN THE FORM ==================-\\
  public UserIsReplicated_Update(): boolean {

    const ValueReviwer = this.FormCCPUpdate.controls['Reviwer'].value;
    const ValueApprover = this.FormCCPUpdate.controls['Approver'].value;

    if (ValueReviwer === null || ValueReviwer === '' || this.NameFileCCPUpdate.invalid) return false;

    if (ValueApprover === null || ValueApprover === '' || this.NameFileCCPUpdate.invalid) return false;

    return ValueReviwer.ID === ValueApprover.ID;

  }

  //-================== FUNCTION FOR VALIDATE FORM CCP UPDATE ==================-\\
  private IsValidFormCCPUpdate(): boolean {


    const IdInputFileNewCCPUpdate = document.getElementById('IdInputFileNewCCPUpdate') as HTMLInputElement; IdInputFileNewCCPUpdate.classList.remove('Is-Invalid-Form');
    const IdInputKeyWNewCCPUpdate = document.getElementById('IdInputKeyWNewCCPUpdate') as HTMLInputElement;
    const IdInputSeleNewCCPUpdate = document.getElementById('IdInputSeleNewCCPUpdate') as HTMLElement;
    const IdinputShopNewCCPUpdate = document.getElementById('IdinputShopNewCCPUpdate') as HTMLElement;
    const IdinputAreaNewCCPUpdate = document.getElementById('IdinputAreaNewCCPUpdate') as HTMLElement;
    const IdInputAuReNewCCPUpdate = document.getElementById('IdInputAuReNewCCPUpdate') as HTMLElement;
    const IdInputAuApNewCCPUpdate = document.getElementById('IdInputAuApNewCCPUpdate') as HTMLElement;
    const IdinputInvoiceCCPUpdate = document.getElementById('IdinputInvoiceCCPUpdate') as HTMLInputElement;
    const IdInputCodeNewCCPUpdate = document.getElementById('IdInputCodeNewCCPUpdate') as HTMLInputElement;
    const IdNoRevOne1NewCCPUpdate = document.getElementById('IdNoRevOne1NewCCPUpdate') as HTMLInputElement;

    if (!this.FormCCPUpdate.controls['NameCCP'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Archivo no valido',
        text: '¡Ingrese un archivo HOE para actualización!',
        confirmButtonColor: this.ColorConfirm
      })
      IdInputFileNewCCPUpdate.classList.add('Is-Invalid-Form');
      return false;
    }

    // if (!this.FormCCPUpdate.controls['KeyWord'].valid) {
    //   Swal.fire({
    //     icon: 'warning',
    //     title: 'KeyWord no valida',
    //     text: '¡Ingrese una keyWord valida!',
    //     confirmButtonColor: this.ColorConfirm
    //   })
    //   IdInputKeyWNewCCPUpdate.classList.add('ng-invalid'); IdInputKeyWNewCCPUpdate.classList.add('ng-touched');
    //   return false;
    // }

    if (!this.FormCCPUpdate.controls['Model_Year'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Model Year no valido',
        text: '¡Seleccione un model year en la lista proporcionada!',
        confirmButtonColor: this.ColorConfirm
      })
      IdInputSeleNewCCPUpdate.classList.add('ng-invalid'); IdInputSeleNewCCPUpdate.classList.add('ng-touched');
      return false;
    }

    if (!this.FormCCPUpdate.controls['Shop'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'La Shop no es válida',
        text: '¡Por favor, asegúrese de seleccionar una Shop proporcionada por el sistema!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputShopNewCCPUpdate.classList.add('ng-invalid'); IdinputShopNewCCPUpdate.classList.add('ng-touched');
      return false;
    }

    if (!this.FormCCPUpdate.controls['Area'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'El Area no es válida',
        text: '¡Por favor, asegúrese de seleccionar una Area proporcionada por el sistema!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputAreaNewCCPUpdate.classList.add('ng-invalid'); IdinputAreaNewCCPUpdate.classList.add('ng-touched');
      return false;
    }


    if (!this.FormCCPUpdate.controls['Reviwer'].valid) {

      Swal.fire({
        icon: 'warning',
        title: 'Usuario revisor no valido',
        text: '¡No ha seleccionado a un revisor, por favor seleccione uno!',
        confirmButtonColor: this.ColorConfirm
      })

      IdInputAuReNewCCPUpdate.classList.add('ng-invalid'); IdInputAuReNewCCPUpdate.classList.add('ng-touched');
      return false;

    } else {

      const ValueReviwer: User_CDMS = this.FormCCPUpdate.controls['Reviwer'].value;

      if (ValueReviwer.ID === undefined) {
        Swal.fire({
          icon: 'warning',
          title: 'Usuario revisor no valido',
          text: '¡Seleccione un usuario revisor proporcionado por el sistema!',
          confirmButtonColor: this.ColorConfirm
        });

        IdInputAuReNewCCPUpdate.classList.add('ng-invalid'); IdInputAuReNewCCPUpdate.classList.add('ng-touched');
        return false;
      }

    }

    if (!this.FormCCPUpdate.controls['Approver'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Usuario aprobador no valido',
        text: '¡No ha seleccionado a un aprobador, por favor seleccione uno!',
        confirmButtonColor: this.ColorConfirm
      })

      IdInputAuApNewCCPUpdate.classList.add('ng-invalid'); IdInputAuApNewCCPUpdate.classList.add('ng-touched');
      return false;

    } else {

      const ValueApprover: User_CDMS = this.FormCCPUpdate.controls['Approver'].value;

      if (ValueApprover.ID === undefined) {
        Swal.fire({
          icon: 'warning',
          title: 'Usuario aprobador no valido',
          text: '¡Seleccione un usuario aprobador proporcionado por el sistema!',
          confirmButtonColor: this.ColorConfirm
        });

        IdInputAuApNewCCPUpdate.classList.add('ng-invalid'); IdInputAuApNewCCPUpdate.classList.add('ng-touched');
        return false;
      }

    }

    if (!this.FormCCPUpdate.controls['Invoice_4M'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Folio 4M no valido',
        text: '¡Ingrese un folio de 4M!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputInvoiceCCPUpdate.classList.add('ng-invalid'); IdinputInvoiceCCPUpdate.classList.add('ng-touched');
      return false;
    }

    if (!this.FormCCPUpdate.controls['Code_CCP'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Código no valido',
        text: '¡Ingrese un código de HOE!',
        confirmButtonColor: this.ColorConfirm
      })

      IdInputCodeNewCCPUpdate.classList.add('ng-invalid'); IdInputCodeNewCCPUpdate.classList.add('ng-touched');
      return false;
    }

    if (!this.FormCCPUpdate.controls['NoRevCCP'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'No. Revisión no valido',
        text: '¡ingrese un numero de revisión valido, número mayor a 0 o N!',
        confirmButtonColor: this.ColorConfirm
      })
      IdNoRevOne1NewCCPUpdate.classList.add('ng-invalid'); IdNoRevOne1NewCCPUpdate.classList.add('ng-touched');
      return false;

    }

    // const ValueReviwer: User_CDMS = this.FormCCPUpdate.controls['Reviwer'].value;
    // const ValueApprover: User_CDMS = this.FormCCPUpdate.controls['Approver'].value;

    // if (ValueReviwer.ID === ValueApprover.ID) {
    //   Swal.fire({
    //     icon: 'warning',
    //     title: 'Usuarios repetidos',
    //     text: '¡No puede repetir los usuarios en los campos, intente cambiar alguno usuario!',
    //     confirmButtonColor: this.ColorConfirm
    //   });

    //   IdInputAuReNewCCPUpdate.classList.add('ng-invalid'); IdInputAuReNewCCPUpdate.classList.add('ng-touched');
    //   IdInputAuApNewCCPUpdate.classList.add('ng-invalid'); IdInputAuApNewCCPUpdate.classList.add('ng-touched');

    //   return false;
    // }

    return true;
  }

  //-================== FUNCTION FOR VALIDATE OPEN OR CLOSE MODAL NOTIFICATION ==================-\\
  public ValidToogleCCPUpdate(): void {
    const IsValidForm: boolean = this.IsValidFormCCPUpdate();

    if (this.FormCCPUpdate.valid && IsValidForm) {
      this.Toggle_Modal_Sweet_Alert_SendCCP_Update(true);
    }
  }

  public Toggle_Modal_Sweet_Alert_SendCCP_Update(band: boolean): void {
    const modal = document.getElementById('Sweet_Alert_Update') as HTMLDivElement;
    setTimeout(() => { band ? (modal.classList.add('active')) : (modal.classList.remove('active')) }, 100);

  }

  public Sweet_Alert_Send_New_CCP_Update(): void {
    this.Toggle_Modal_Sweet_Alert_SendCCP_Update(false);
    this.Validate_Open_Notification_Update();
  }

  public Validate_Open_Notification_Update(): void {
    const IsValidForm: boolean = this.IsValidFormCCPUpdate();

    if (this.FormCCPUpdate.valid && IsValidForm) {


      if (this.ShopSelected! && this.ShopSelected.ShopNotification.length > 0) {
        this.ToggleModalNotificationUpdate(true);
      } else {
        Swal.fire({
          title: 'Notificación a grupos',
          text: "¡Aún no existen grupos para enviar notificación de la creación de una nueva HOE!",
          icon: 'question',
          confirmButtonColor: this.ColorConfirm,
        }).then((result2) => {
          if (result2.isConfirmed) {
            this.SendUpdateCCP([0]);
          }
        })
      }

    }
  }

  //-================== FUNCTION TO CHECK NOTIFICATION TO GROUPS ==================-\\
  private Check_Notification_Update(): number[] {

    let Id_Groups: number[] = [];

    for (let i = 0; i < this.ShopSelected.ShopNotification.length; i++) {
      const Group = this.ShopSelected.ShopNotification[i];
      const CheckBox = document.getElementById(`CheckBoxUpdate${i}`) as HTMLInputElement;
      if (CheckBox.checked) {
        Id_Groups.push(Group.ID);
        CheckBox.checked = false;
      }
    }

    return Id_Groups;

  }

  //-================== FUNCTION FOR SAVED UPDATE CCP ==================-\\
  public SavedUpdateCCP(): void {

    const Id_Groups: number[] = this.Check_Notification_Update();

    const IsValidForm: boolean = this.IsValidFormCCPUpdate();

    if (this.FormCCPUpdate.valid && IsValidForm) {

      if (Id_Groups.length === 0) {
        Swal.fire({
          title: 'Sin notificación a grupos',
          text: "¡No ha seleccionado ningún grupo para notificación, ¿desea continuar sin notificaciones?!",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, continuar',
          cancelButtonText: 'No, Cancelar',
        }).then((results => {
          if (results.isConfirmed) {
            this.SendUpdateCCP(Id_Groups);
          }
        }))

      } else {

        Swal.fire({
          title: '¿Los grupos a notificar son correctos?',
          text: "Si todo esta bien, presiona el botón para continuar",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, son correctos',
          cancelButtonText: 'No, Cancelar',
        }).then((result => {
          if (result.isConfirmed) {
            this.SendUpdateCCP(Id_Groups);
          }
        }))
      }

    }
  }

  //-================== FUNCTION FOR CHECK IF EXIST CCP IN PATH ==================-\\
  private Check_CCP_in_Path_Directory(NameFile: string, ID_CCP: number): boolean {

    let Exist: boolean = false;

    this.All_FAF_CCP.map((item: FILE_CCP) => {
      if (item.Name === NameFile && item.ID != ID_CCP) {
        Exist = true;
      }
    })

    return Exist;
  }

  //-================== FUNCTION SEND UPDATE CCP ==================-\\
  private async SendUpdateCCP(Groups: number[]): Promise<void> {


    const NewNameCom = this.FormCCPUpdate.controls['NameCCP'].value;
    const IsExistinPath = this.Check_CCP_in_Path_Directory(NewNameCom, this.FCCP_Select_CM.ID);

    this.ToggleModalNotificationUpdate(false);

    if (IsExistinPath) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: `No puedes guardar esta actualización `,
        text: `¡La HOE que proporcionó ya existe en el directorio y no es actualización de esta misma!`,
        confirmButtonColor: this.ColorConfirm
      })
      this.ToggleModalUpdateCCP(false);


    } else {

      this.OnDisabledUpdate(true);

      const UserReviewer: User_CDMS = this.FormCCPUpdate.controls['Reviwer'].value;
      const UserApprover: User_CDMS = this.FormCCPUpdate.controls['Approver'].value;

      const Tasks: Task[] = [{ ID_Involved_User: UserReviewer.ID, ID_UR: 1 }, { ID_Involved_User: UserApprover.ID, ID_UR: 2 }];

      const SC_Workflow: Create_WorkFlow = {
        ID_Contributor: this.ID_User_BD,
        ID_Previous_Version: this.FCCP_Select_CM.ID,
        ID_Next_Version: null,
        Name: this.FormCCPUpdate.controls['NameCCP'].value,
        Extension: this.FormCCPUpdate.controls['NameCCP'].value.split('.').pop(),
        // Key_Word: this.FormCCPUpdate.controls['KeyWord'].value,
        Model_Year: this.FormCCPUpdate.controls['Model_Year'].value || 0,
        Code: this.FormCCPUpdate.controls['Code_CCP'].value,
        Revision_No: this.FormCCPUpdate.controls['NoRevCCP'].value,
        Invoice_4M: this.FormCCPUpdate.controls['Invoice_4M'].value,
        ID_Folder: this.ID_Folder_Level,
        Shop: (this.FormCCPUpdate.controls['Shop'].value).ID,
        Area: (this.FormCCPUpdate.controls['Area'].value).ID,
        Current_Version: true,
        tasks: Tasks,
        Notification: Groups,
        route: encodeURIComponent(this.Route_Level_Global)
      };

      const fileCCP: File = this.FileAuxUpdCCP.FileData;

      const Content_Progress = document.getElementById('Content-Progress-Update') as HTMLDivElement;
      const Progress_Bar = document.getElementById('Progress-Bar-Update') as HTMLDivElement;
      Content_Progress.classList.add('active')

      try {

        this.Service_CCP.CreateWorkflow(SC_Workflow, fileCCP).subscribe((event: any) => {

          if (event.status === 404) {

            this.OnDisabledUpdate(false);
            Content_Progress.classList.remove('active');
            Progress_Bar.style.width = "0%";

            Swal.fire({
              title: 'Error en la HOE',
              text: '¡No se guardo el archivo de la HOE en el sistema, informa a tu supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            this.ToggleModalUpdateCCP(false);
            this.SeeFolder_BreadCrum(this.NumberTopL);

          }

          if (event.status === 500) {

            this.OnDisabledUpdate(false);
            Content_Progress.classList.remove('active');
            Progress_Bar.style.width = "0%";

            Swal.fire({
              title: 'Error en la HOE',
              text: '¡Ha ocurrido un error al actualizar la versión anterior en el sistema, no afecta la carga de la HOE, de igual manera informe al supervisor!',
              icon: 'warning',
              confirmButtonColor: this.ColorConfirm
            })

            this.ToggleModalUpdateCCP(false);
            this.SeeFolder_BreadCrum(this.NumberTopL);

          }


          if (event['loaded'] && event['total']) {
            let value = (Math.round(event['loaded'] / event['total'] * 100));
            Progress_Bar.style.width = value + "%";
          }

          if (event['body']) {

            this.OnDisabledUpdate(false);
            Content_Progress.classList.remove('active');
            Progress_Bar.style.width = "0%";

            this.ToggleModalUpdateCCP(false);
            Swal.fire({
              icon: 'success',
              title: 'Actualización de HOE enviada a revisión',
              confirmButtonColor: this.ColorConfirm
            })
            this.SeeFolder_BreadCrum(this.NumberTopL);
          }
        })

      } catch (e) {

        this.OnDisabledUpdate(false);
        Content_Progress.classList.remove('active');
        Progress_Bar.style.width = "0%";

        Swal.fire({
          title: 'Error en la HOE',
          text: '¡No se guardo el archivo de la HOE en el sistema, informa a tu supervisor!',
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        });

        this.ToggleModalUpdateCCP(false);
        this.SeeFolder_BreadCrum(this.NumberTopL);
      }

    }

  }

  //-================== FUNCTION DISABLED BUTONS WHILE SEND CCP ==================-\\
  private OnDisabledUpdate(IsDisabled: boolean): void {
    const Btn_Saved_Update = document.getElementById('Btn-Saved-Update') as HTMLButtonElement;
    const Btn_Close_Update_Top = document.getElementById('Btn-Close-Update-Top') as HTMLButtonElement;
    const Btn_Close_Update_Bottom = document.getElementById('Btn-Close-Update-Bottom') as HTMLButtonElement;

    if (IsDisabled) {
      Btn_Saved_Update.disabled = true;
      Btn_Close_Update_Top.disabled = true;
      Btn_Close_Update_Bottom.disabled = true;
    } else {
      Btn_Saved_Update.disabled = false;
      Btn_Close_Update_Top.disabled = false;
      Btn_Close_Update_Bottom.disabled = false;

    }

  }

  //&===================== END FUNCTIONS FOR UPDATE CCP =====================&\\




  //&===================== FUNCTIONS FOR CONTEXT-MENU-CLICK =====================&\\


  //-================== FUNCTION FOR OPEN CONTEXT MENU ==================-\\
  public RightClick_Context_Menu($event: any, CCP: FILE_CCP, fromMobileButton: boolean = false): void {
    if (this.isMobileDevice && !fromMobileButton) {
      $event.preventDefault?.();
      return;
    }

    $event.preventDefault();
    if (fromMobileButton || $event.which === 3) {
      const pop: any = document.getElementById('Context-Menu');
      if ($event.clientY > 700) {
        pop.style.top = $event.clientY - 250 + "px";
      } else {
        pop.style.top = $event.clientY - 20 + "px";
      }
      pop.style.left = $event.clientX - 10 + "px";
      pop.classList.add('active');
    }
    this.FCCP_Select_CM = CCP;
    console.log(this.FCCP_Select_CM);
  }

  get isMobileDevice(): boolean {
    return window.innerWidth <= 1024 || ('ontouchstart' in window);
  }

  //-================== FUNCTION FOR CLOSE CONTEXT MENU ==================-\\
  public Close_Context_Menu(): void {
    const Context_Menu = document.getElementById('Context-Menu') as HTMLDivElement;
    Context_Menu.classList.remove('active');
  }

  //-================== FUNCTIONS FOR RENAME FILE OR DIRECTORY ==================-\\

  // ============== FUNCTION FOR OPEN OR CLOSE MODAL RENAME ==============\\
  public ToggleModalRename(CloseOrOpen: boolean): void {
    this.FillNameFormRFD();
    const ModalRenameFD = document.getElementById('ModalRenameFD') as HTMLDivElement;
    CloseOrOpen ? ModalRenameFD.classList.add('active') : ModalRenameFD.classList.remove('active');
  }
  // ============== FUNCTION FOR FILL NAME IN FORM ==============\\
  private FillNameFormRFD(): void {
    this.FormRenameFD.reset();
    let NameFoD: string;
    if (this.FCCP_Select_CM.Directory) {
      NameFoD = this.FCCP_Select_CM.Name;
    } else {
      let Name_Split: string[] = this.FCCP_Select_CM.Name.split('.'); Name_Split.pop();
      NameFoD = Name_Split.join('.');
    }
    this.FormRenameFD.controls['NameRename'].setValue(NameFoD);
  }

  // ============== FUNCTION TO CHECK IF A FILE OR DIRECTORY IS RENAMED ==============\\
  public RenameFD(): void {

    this.FCCP_Select_CM.Directory ? (this.RenameDirectory()) : (this.RenameFileCCP());

  }

  // ============== FUNCTION TO RENAME DIRECTORY ==============\\
  private RenameDirectory(): void {

    const NewNameCom = this.FormRenameFD.controls['NameRename'].value;
    const IsExistinPath = this.Check_CCP_in_Path_Directory(NewNameCom, this.FCCP_Select_CM.ID);

    if (IsExistinPath) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: `No puede renombrar la carpeta con este nombre `,
        text: `¡La carpeta ya existe en este directorio!`,
        confirmButtonColor: this.ColorConfirm
      })
    } else if (this.FormRenameFD.valid) {

      const CCPComp = this.FCCP_Select_CM;
      const ID_CCPC = CCPComp.ID;

      const NewName = this.FormRenameFD.get('NameRename')?.value;


      Swal.fire({
        title: `Renombrar carpeta`,
        text: `¿Usted está seguro de cambiar el nombre de la carpeta?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, renombrar! '
      }).then(async (result: any) => {

        if (result.isConfirmed) {

          try {
            const ResRenameFolder: any = await firstValueFrom(this.Service_CCP.RenameFolder({ ID: ID_CCPC, NewName: NewName }));


            if (ResRenameFolder.success) {
              Swal.fire({
                title: 'Carpeta renombrada',
                text: '¡La carpeta se renombró correctamente!',
                icon: 'success',
                confirmButtonColor: this.ColorConfirm
              });
            }

            this.ToggleModalRename(false);
            this.SeeFolder_BreadCrum(this.NumberTopL);

          } catch (e) {

            Swal.fire({
              title: 'Error al renombrar',
              text: '¡Error al renombrar carpeta, notifique a su supervisor!',
              icon: 'error',
              confirmButtonColor: this.ColorConfirm
            })
            this.ToggleModalRename(false);
            this.SeeFolder_BreadCrum(this.NumberTopL);
          }

        }
      })

    } else {
      Swal.fire({
        title: 'Nombre no valido',
        text: `¡No se permiten los siguientes caracteres \ / : * ? " < > | !`,
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }


  }

  // ============== FUNCTION FOR RENAME FILE ==============\\
  private RenameFileCCP(): void {

    const NewNameCom = this.FormRenameFD.controls['NameRename'].value + '.' + this.FCCP_Select_CM.Extension;
    const IsExistinPath = this.Check_CCP_in_Path_Directory(NewNameCom, this.FCCP_Select_CM.ID);


    if (IsExistinPath) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: `No puede renombrar la HOE con este nombre `,
        text: `¡La HOE ya existe en este directorio!`,
        confirmButtonColor: this.ColorConfirm
      })
    } else if (this.FormRenameFD.valid) {

      const CCPComp = this.FCCP_Select_CM;
      const ID_CCPC = CCPComp.ID;

      const NewName = this.FormRenameFD.controls['NameRename'].value + '.' + this.FCCP_Select_CM.Extension;

      Swal.fire({
        title: `Renombrar HOE`,
        text: `¿Está seguro de cambiar el nombre de la HOE?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, renombrar! '
      }).then(async (result: any) => {

        if (result.isConfirmed) {
          try {

            const ResRenameFileCCP: any = await firstValueFrom(this.Service_CCP.RenameFileCCP({ ID: ID_CCPC, NewName: NewName }));

            if (ResRenameFileCCP.success) {
              Swal.fire({
                title: 'HOE Renombrada',
                text: '¡La HOE se renombró correctamente!',
                icon: 'success',
                confirmButtonColor: this.ColorConfirm
              })
            }

            this.ToggleModalRename(false);
            this.SeeFolder_BreadCrum(this.NumberTopL);

          } catch (e) {

            Swal.fire({
              title: 'Error al renombrar',
              text: '¡Error al renombrar carpeta, notifique a su supervisor!',
              icon: 'error',
              confirmButtonColor: this.ColorConfirm
            })
            this.ToggleModalRename(false);
            this.SeeFolder_BreadCrum(this.NumberTopL);
          }
        }

      })

    } else {
      Swal.fire({
        title: '¡Nombre no valido!',
        text: `No se permiten los siguientes caracteres \ / : * ? " < > |`,
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  //-================== FUNCTION TO APPROVED FOR ADMINISTRATOR ==================-\\
  public Approve_CCP_For_Admin(): void {

    if (this.FCCP_Select_CM.Status != 2) {

      let Status: string = '';

      (this.FCCP_Select_CM.Status === 1) ? (Status = 'aprobada') : (Status = 'rechazada')

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'No puede aprobar esta HOE',
        text: `¡La CCP seleccionada ya fue ${Status}!`,
        confirmButtonColor: this.ColorConfirm,
      })
    } else {
      Swal.fire({
        title: '¿Está Seguro de Aprobar la HOE?',
        text: "¡Los revisores ya no podrán revisar esta HOE!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, aprobar!'
      }).then(async (result) => {
        if (result.isConfirmed) {


          try {

            const ResApprovedAdmin: any = await firstValueFrom(this.Service_CCP.ApproveCCPToAdmin({ ID_WF: this.FCCP_Select_CM.ID }));

            if (ResApprovedAdmin.success) {
              Swal.fire({
                icon: 'success',
                title: 'HOE Aprobada',
                text: '¡La HOE se aprobó correctamente!',
                confirmButtonColor: this.ColorConfirm,
              })
            }

            this.SeeFolder_BreadCrum(this.NumberTopL);

          } catch (e) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: '¡Ocurrió un error al aprobar la HOE!',
              confirmButtonColor: this.ColorConfirm,
            })
            this.SeeFolder_BreadCrum(this.NumberTopL);
          }

        }
      })
    }
  }

  //-================== FUNCTION TO REJECT FOR ADMINISTRATOR ==================-\\
  public Reject_CCP_For_Admin(): void {
    if (this.FCCP_Select_CM.Status != 2) {
      let Status: string = '';

      (this.FCCP_Select_CM.Status === 1) ? (Status = 'aprobada') : (Status = 'rechazada')

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'No puede rechazar esta HOE',
        text: `¡La CCP seleccionada ya fue ${Status}!`,
        confirmButtonColor: this.ColorConfirm,
      })
    } else {
      this.ToggleModalReasonReject(true);
    }
  }

  //-================== FUNCTION TO SEE VERSION HISTORY ==================-\\
  public See_version_History(): void {
    window.open(`${URLs.URLINDEX}/Dashboard/CCP/History/${this.FCCP_Select_CM.ID}/${this.ID_Folder_Level}`)
  }

  //-================== FUNCTION TO PROPERTIES ==================-\\

  public IsChangeEventCCP(event: any) {
    if (event) {
      this.SeeFolder_BreadCrum(this.NumberTopL);
    } else {
      Swal.fire({
        title: 'Error en el Proceso',
        text: '¡Ha ocurrido un error, informe al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  //-================== FUNCTION TO SHOW SIDEBAR =================-\\
  public EmitShowSidebar(): void {
    this.Right_Sidebar_Visible = true;
    this.Close_Context_Menu();
  }

  public ShowSide($event: any): void {

    const Show: boolean = $event as boolean;

    this.Right_Sidebar_Visible = Show;

  }

  // ============== FUNCTION FOR OPEN OR CLOSE MODAL PROPERTIES ==============\\
  public async ToggleModalProperties(CloseOrOpen: boolean): Promise<void> {

    const ModalProperties = document.getElementById('ModalProperties') as HTMLDivElement;

    if (CloseOrOpen) {

      if (await this.Fill_Properties()) {
        ModalProperties.classList.add('active')
      } else {
        this.Reset_Form_Properties();
      }

    } else {
      ModalProperties.classList.remove('active');
      this.Reset_Form_Properties();
    }

  }


  private async Fill_Properties(): Promise<boolean> {
    try {

      const ResDataFIN: Response_CCP = await firstValueFrom(this.Service_CCP.Get_Info_Of_CCP({ ID_CCP: this.FCCP_Select_CM.ID }));

      if (ResDataFIN.success) {
        this.FILE_CCP_Properties = ResDataFIN.operation;

        let Name_Split: string[] = this.FILE_CCP_Properties.Name.split('.'); Name_Split.pop();
        const Namefile = Name_Split.join('.');


        let UserReviewer: User_CDMS = { ID: this.FILE_CCP_Properties.TaskReviewer.ID_Involved_User, Name: this.FILE_CCP_Properties.Reviewer_Name };
        let UserApprover: User_CDMS = { ID: this.FILE_CCP_Properties.TaskApprover.ID_Involved_User, Name: this.FILE_CCP_Properties.Approver_Name };

        const FindShop: Shop_Area_CCP = this.Shops.find((item) => item.ID === this.FCCP_Select_CM.Shop) ?? { ID: 0, Name: '', Area: [] }
        const FindArea: Area_CCP = FindShop.Area.find((item) => item.ID === this.FCCP_Select_CM.Area) ?? { ID: 0, Name: '' }


        this.FormCCPProperties.controls['NameCCP'].setValue(Namefile)
        // this.FormCCPProperties.controls['KeyWord'].setValue(this.FILE_CCP_Properties.Key_Word)
        this.FormCCPProperties.controls['Model_Year'].setValue(this.FILE_CCP_Properties.Model_Year)
        this.FormCCPProperties.controls['Code_CCP'].setValue(this.FILE_CCP_Properties.Code)
        this.FormCCPProperties.controls['NoRevCCP'].setValue(this.FILE_CCP_Properties.Revision_No)
        this.FormCCPProperties.controls['Invoice_4M'].setValue(this.FILE_CCP_Properties.Invoice_4M)
        this.FormCCPProperties.controls['Shop'].setValue(FindShop)
        this.FormCCPProperties.controls['Area'].setValue(FindArea)
        this.FormCCPProperties.controls['Reviwer'].setValue(UserReviewer)
        this.FormCCPProperties.controls['Approver'].setValue(UserApprover)

      }
      return true;

    } catch (e) {

      Swal.fire({
        icon: 'warning',
        title: 'Error al abrir las propiedades',
        text: '¡No se cargó correctamente la data del archivo, notifica a tu supervisor!',
        confirmButtonColor: this.ColorConfirm
      });
      return false;
    }
  }

  // ============== FUNCTION RESET FORM PROPERTIES ==============\\
  private Reset_Form_Properties(): void {
    this.FormCCPProperties.reset();
    this.FILE_CCP_Properties = {
      ID: 0,
      Extension: '',
      Name: '',
      Key_Word: '',
      Revision_No: '',
      Model_Year: 0,
      Code: '',
      Invoice_4M: '',
      Status: 0,
      Area: 0,
      Shop: 0,
      ID_Folder: 0,
      TaskReviewer: {
        ID: 0,
        ID_Involved_User: 0,
        ID_UR: 0,
        Status: 0,
      },
      TaskApprover: {
        ID: 0,
        ID_Involved_User: 0,
        ID_UR: 0,
        Status: 0,
      },
      Date_Created: null,
      Date_Expiration: null,
      Date_End: null,
      ID_Contributor: '',
      Directory: false,
      Reviewer_Name: '',
      Approver_Name: '',
      Contributor_Name: '',
      Path: '',
    }
  }

  // ============== FUNCTION CHECK EDIT TASK ==============\\
  public CheckEditTask(Reviwer: Data_Inv | null): boolean {

    if (Reviwer === null) {
      return false;
    }
    if ((Reviwer.Status == 1 || Reviwer.Status == 2)) {
      return true;
    }
    return false;
  }

  // ============== FUNCTION STATUS TASK ==============\\
  public Check_Status_Task_Icon(Reviwer: Data_Inv | null): number {
    if (Reviwer === null) {
      return 0;
    } else {
      return Reviwer.Status;
    }

  }

  // ============== FUNCTION FOR ICON TASK ==============\\
  public Get_Icon_Task(Status: number): string {
    switch (Status) {
      case 1: return 'fa-user-pen';
      case 2: return 'fa-user-clock';
      case 3: return 'fa-user-check';
      case 4: return 'fa-user-xmark';
      case 5: return 'fa-user-shield';
      case 6: return 'fa-user-shield';
      case 7: return 'fa-users-slash';
      default: return '';
    }
  }

  // ============== FUNCTION FOR SAVED PROPERTIES ==============\\
  public SaveEditProperties(): void {

    let Array_Task: Data_Inv[] = [];

    const IsValidProp = this.IsValidFormCCPProperties();

    const NewNameCCP = this.FormCCPProperties.controls['NameCCP'].value + '.' + this.FCCP_Select_CM.Extension;
    // const NewKeyWord = this.FormCCPProperties.controls['KeyWord'].value;
    const NewModel_Year = this.FormCCPProperties.controls['Model_Year'].value || 0;
    const NewCode_CCP = this.FormCCPProperties.controls['Code_CCP'].value;
    const NewNoRevCCP = this.FormCCPProperties.controls['NoRevCCP'].value;
    const NewInvoice_4M = this.FormCCPProperties.controls['Invoice_4M'].value;
    const NewReviewer: User_CDMS = this.FormCCPProperties.controls['Reviwer'].value;
    const NewApprover: User_CDMS = this.FormCCPProperties.controls['Approver'].value;

    const Set_Reviewer: Data_Inv = { ID: this.FILE_CCP_Properties.TaskReviewer.ID, ID_Involved_User: NewReviewer.ID, ID_UR: 1, Status: this.FILE_CCP_Properties.TaskReviewer.Status };
    const Set_Approver: Data_Inv = { ID: this.FILE_CCP_Properties.TaskApprover.ID, ID_Involved_User: NewApprover.ID, ID_UR: 2, Status: this.FILE_CCP_Properties.TaskApprover.Status }

    let Task_Edit: Data_Inv[] = [];

    Array_Task.push(Set_Reviewer);
    Array_Task.push(Set_Approver);

    for (const Task of Array_Task) {
      if (Task.Status === 1 || Task.Status === 2) {
        Task_Edit.push(Task);
      }
    }

    const Send_CCP_Update: Update_CCP = {
      ID: this.FCCP_Select_CM.ID,
      Name: NewNameCCP,
      // Key_Word: NewKeyWord,
      Model_Year: NewModel_Year,
      Code: NewCode_CCP,
      Revision_No: NewNoRevCCP,
      Invoice_4M: NewInvoice_4M,
      Tasks: Task_Edit
    };


    const IsExistinPath = this.Check_CCP_in_Path_Directory(NewNameCCP, this.FCCP_Select_CM.ID);


    if (IsExistinPath) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'La HOE ya existe en este directorio ',
        text: '¡No puede renombrar la HOE con este nombre!',
        confirmButtonColor: this.ColorConfirm
      })
    } else if (this.FormCCPProperties.valid && IsValidProp) {
      Swal.fire({
        title: '¿Los datos son correctos?',
        text: `Estas modificando las propiedades de ${this.FCCP_Select_CM.Name}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, son correctos!',
        cancelButtonText: 'No, Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {

            const ResUpdateCCP: any = await firstValueFrom(this.Service_CCP.UpdateCCP(Send_CCP_Update));

            Swal.fire({
              icon: 'success',
              title: 'Las propiedades de la HOE se modificaron correctamente',
              confirmButtonColor: this.ColorConfirm
            })
            this.ToggleModalProperties(false);
            this.SeeFolder_BreadCrum(this.NumberTopL);

          } catch (e) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: '¡Ocurrio un error al cambiar las propiedades de la HOE, notifica a tu supervisor!',
              confirmButtonColor: this.ColorConfirm,
            })
            this.ToggleModalProperties(false);
            this.SeeFolder_BreadCrum(this.NumberTopL);
          }
        }
      })
    }
  }

  // ============== FUNCTION TO CHECK THAT THE USERS ARE NOT REPLICATED IN THE FORM ==============\\
  public UserIsReplicated_Properties(): boolean {

    const ValueReviwer = this.FormCCPProperties.controls['Reviwer'].value;
    const ValueApprover = this.FormCCPProperties.controls['Approver'].value;

    if (ValueReviwer === null || ValueReviwer === '') return false;

    if (ValueApprover === null || ValueApprover === '') return false;

    return ValueReviwer.ID === ValueApprover.ID;

  }

  // ============== FUNCTION FOR VALIDATE FORM PROPERTIES ==============\\
  private IsValidFormCCPProperties(): boolean {

    const IdInputFileCCPProperties = document.getElementById('IdInputFileCCPProperties') as HTMLInputElement;
    const IdInputKeyWCCPProperties = document.getElementById('IdInputKeyWCCPProperties') as HTMLInputElement;
    const IdInputSeleCCPProperties = document.getElementById('IdInputSeleCCPProperties') as HTMLElement;
    const IdInputAuReCCPProperties = document.getElementById('IdInputAuReCCPProperties') as HTMLElement;
    const IdInputAuApCCPProperties = document.getElementById('IdInputAuApCCPProperties') as HTMLElement;
    const IdinputInvoiceProperties = document.getElementById('IdinputInvoiceProperties') as HTMLInputElement;
    const IdInputCodeCCPProperties = document.getElementById('IdInputCodeCCPProperties') as HTMLInputElement;
    const IdNoRevOne1CCPProperties = document.getElementById('IdNoRevOne1CCPProperties') as HTMLInputElement;

    if (!this.FormCCPProperties.controls['NameCCP'].valid) {

      if (this.FormCCPProperties.controls['NameCCP'].value === '') {
        Swal.fire({
          icon: 'warning',
          title: 'Nombre no valido',
          text: '¡Ingrese un nombre valido!',
          confirmButtonColor: this.ColorConfirm
        })
      } else {
        Swal.fire({
          title: 'Nombre no valido',
          text: `¡No se permiten los siguientes caracteres \ / : * ? " < > | !`,
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })
      }

      IdInputFileCCPProperties.classList.add('ng-invalid'); IdInputFileCCPProperties.classList.add('ng-touched');

      return false;
    }

    // if (!this.FormCCPProperties.controls['KeyWord'].valid) {
    //   Swal.fire({
    //     icon: 'warning',
    //     title: 'KeyWord no valida',
    //     text: '¡Ingrese una keyWord valida!',
    //     confirmButtonColor: this.ColorConfirm
    //   })
    //   IdInputKeyWCCPProperties.classList.add('ng-invalid'); IdInputKeyWCCPProperties.classList.add('ng-touched');
    //   return false;
    // }

    if (!this.FormCCPProperties.controls['Model_Year'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Model Year no valido',
        text: '¡Seleccione un model year en la lista proporcionada!',
        confirmButtonColor: this.ColorConfirm
      })
      IdInputSeleCCPProperties.classList.add('ng-invalid'); IdInputSeleCCPProperties.classList.add('ng-touched');
      return false;
    }


    if (!this.FormCCPProperties.controls['Reviwer'].valid) {

      Swal.fire({
        icon: 'warning',
        title: 'Usuario revisor no valido',
        text: '¡No ha seleccionado a un revisor, por favor seleccione uno!',
        confirmButtonColor: this.ColorConfirm
      })

      IdInputAuReCCPProperties.classList.add('ng-invalid'); IdInputAuReCCPProperties.classList.add('ng-touched');
      return false;

    } else {

      const ValueReviwer: User_CDMS = this.FormCCPProperties.controls['Reviwer'].value;

      if (ValueReviwer.ID === undefined) {
        Swal.fire({
          icon: 'warning',
          title: 'Usuario revisor no valido',
          text: '¡Seleccione un usuario revisor proporcionado por el sistema!',
          confirmButtonColor: this.ColorConfirm
        });

        IdInputAuReCCPProperties.classList.add('ng-invalid'); IdInputAuReCCPProperties.classList.add('ng-touched');
        return false;
      }

    }

    if (!this.FormCCPProperties.controls['Approver'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Usuario aprobador no valido',
        text: '¡No ha seleccionado a un aprobador, por favor seleccione uno!',
        confirmButtonColor: this.ColorConfirm
      })

      IdInputAuApCCPProperties.classList.add('ng-invalid'); IdInputAuApCCPProperties.classList.add('ng-touched');
      return false;

    } else {

      const ValueApprover: User_CDMS = this.FormCCPProperties.controls['Approver'].value;

      if (ValueApprover.ID === undefined) {
        Swal.fire({
          icon: 'warning',
          title: 'Usuario aprobador no valido',
          text: '¡Seleccione un usuario aprobador proporcionado por el sistema!',
          confirmButtonColor: this.ColorConfirm
        });

        IdInputAuApCCPProperties.classList.add('ng-invalid'); IdInputAuApCCPProperties.classList.add('ng-touched');
        return false;
      }

    }

    if (!this.FormCCPProperties.controls['Invoice_4M'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Folio 4M no valido',
        text: '¡Ingrese un folio de 4M!',
        confirmButtonColor: this.ColorConfirm
      })
      IdinputInvoiceProperties.classList.add('ng-invalid'); IdinputInvoiceProperties.classList.add('ng-touched');
      return false;
    }

    if (!this.FormCCPProperties.controls['Code_CCP'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'Código no valido',
        text: '¡Ingrese un código de HOE!',
        confirmButtonColor: this.ColorConfirm
      })

      IdInputCodeCCPProperties.classList.add('ng-invalid'); IdInputCodeCCPProperties.classList.add('ng-touched');
      return false;
    }

    if (!this.FormCCPProperties.controls['NoRevCCP'].valid) {
      Swal.fire({
        icon: 'warning',
        title: 'No. Revisión no valido',
        text: '¡ingrese un numero de revisión valido, número mayor a 0 o N!',
        confirmButtonColor: this.ColorConfirm
      })
      IdNoRevOne1CCPProperties.classList.add('ng-invalid'); IdNoRevOne1CCPProperties.classList.add('ng-touched');
      return false;

    }

    // const ValueReviwer: User_CDMS = this.FormCCPProperties.controls['Reviwer'].value;
    // const ValueApprover: User_CDMS = this.FormCCPProperties.controls['Approver'].value;

    // if (ValueReviwer.ID === ValueApprover.ID) {
    //   Swal.fire({
    //     icon: 'warning',
    //     title: 'Usuarios repetidos',
    //     text: '¡No puede repetir los usuarios en los campos, intente cambiar alguno usuario!',
    //     confirmButtonColor: this.ColorConfirm
    //   });

    //   IdInputAuReCCPProperties.classList.add('ng-invalid'); IdInputAuReCCPProperties.classList.add('ng-touched');
    //   IdInputAuApCCPProperties.classList.add('ng-invalid'); IdInputAuApCCPProperties.classList.add('ng-touched');

    //   return false;
    // }

    return true;
  }

  //-================== FUNCTION TO DELETE A FILE OR DIRECTORY ==================-\\

  // ============== FUNCTION FOR VERIFY IF FILE SELECT IS FILE OR DIRECTORY ==============\\
  public Delete_File_or_Directory(): void {

    this.FCCP_Select_CM.Directory ? (this.Delete_Directory_CCP()) : (this.Delete_File_CCP());

  }

  // ============== FUNCTION FOR DELETE FILE CCP ==============\\
  private Delete_File_CCP(): void {

    Swal.fire({
      title: '¿Está seguro de eliminar la HOE?',
      text: "¡Enviara la HOE a papelera de reciclaje!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Marque la casilla para eliminar la HOE!`,
          input: 'checkbox',
          inputPlaceholder: 'Eliminar HOE',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async (result2: any) => {

          if (result2.isConfirmed) {

            if (result2.value === 1) {


              try {

                const ResMoveRBin: any = await firstValueFrom(this.Service_CCP.MoveCCPToRecycleBin({ ID_WF: this.FCCP_Select_CM.ID }))

                if (ResMoveRBin.success) {
                  Swal.fire({
                    icon: 'success',
                    title: 'HOE eliminada',
                    text: '¡Se elimino correctamente la HOE!',
                    confirmButtonColor: this.ColorConfirm
                  });
                }

                this.SeeFolder_BreadCrum(this.NumberTopL);

              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Error al eliminar CCP',
                  text: '¡No se eliminó la HOE, notifica a tu supervisor!',
                  confirmButtonColor: this.ColorConfirm
                });

                this.SeeFolder_BreadCrum(this.NumberTopL);
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin confirmar',
                text: '¡Marque la casilla para eliminar la HOE!',
                confirmButtonColor: this.ColorConfirm
              });

              this.SeeFolder_BreadCrum(this.NumberTopL);
            }

          }


        }))
      }
    })

  }

  // ============== FUNCTION FOR DELETE DIRECTORY ==============\\
  private Delete_Directory_CCP(): void {

    const NameDelete: string = this.FCCP_Select_CM.Name;

    Swal.fire({
      title: '¿Está seguro de eliminar esta carpeta?',
      text: "¡No podrá revertir cambios!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Para eliminar la carpeta escriba ${NameDelete} !`,
          input: 'text',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async result2 => {

          if (result2.isConfirmed) {

            const ValueInput: string = result2.value;

            if (ValueInput.toLowerCase() === NameDelete.toLowerCase()) {


              try {

                const ResDeleteFolder: any = await firstValueFrom(this.Service_CCP.DeleteFolder({ ID_Folder: this.FCCP_Select_CM.ID }));

                Swal.fire({
                  icon: 'success',
                  title: 'Carpeta eliminada',
                  text: '¡Se eliminó correctamente la carpeta!',
                  confirmButtonColor: this.ColorConfirm
                })
                this.SeeFolder_BreadCrum(this.NumberTopL);

              } catch (error) {
                Swal.fire({
                  title: 'Ocurrió un error',
                  text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
                  icon: 'warning',
                  confirmButtonColor: this.ColorConfirm
                })
                this.SeeFolder_BreadCrum(this.NumberTopL);
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin coincidencia',
                text: '¡Escriba correctamente el nombre del directorio para eliminarlo!',
                confirmButtonColor: this.ColorConfirm
              })
            }
          }
        }))
      }
    })
  }

  //-================== FUNCTION TO DOWNLOAD FILE ==================-\\
  public DownloadFile(): void {

    this.DownloadTable(this.FCCP_Select_CM);

  }

  //&===================== END FUNCTIONS FOR CONTEXT-MENU-CLICK =====================&\\




  //&===================== FUNCTIONS FOR GENERAL SYSTEM =====================&\\

  //-================== FUNCTION FOR GET FILES AND FOLDERS IN ROUTE ==================-\\
  private async GetInformationDiretory(Route: string): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    await this.Load_Task();

    const ResCCPDir: any = await firstValueFrom(this.Service_CCP.GetCcpOfDirectory({ path: Route }));

    if (ResCCPDir.success) {
      this.LoadPage = true;

      this.All_FAF_CCP = ResCCPDir.operation.items;
      this.TotalFilesCCP = ResCCPDir.operation.Total_Files;
      this.TotalFoldersC = ResCCPDir.operation.Total_Folders;
      this.cleanFilterTable();

      Loader.classList.remove('active');

      this.Generate_Filters();
    } else {
      Loader.classList.remove('active');
      this.LoadPage = true;
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  //-================== FUNCTION FOR FILTERS ==================-\\
  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Model_Year: [],
      Status: [],
      Reviewer_Name: [],
      Approver_Name: [],
      Contributor_Name: [],
    };

    for (const CCP of this.All_FAF_CCP) {

      CCP.Date_Created = moment(CCP.Date_Created).utc().toDate();
      CCP.Date_Expiration = moment(CCP.Date_Expiration).utc().toDate();

      if (!this.Filter_Global_Check.Extension.includes(CCP.Extension) && CCP.Extension !== null) {
        this.Filter_Global_Check.Extension.push(CCP.Extension);
      }

      if (!this.Filter_Global_Check.Model_Year.includes(CCP.Model_Year) && CCP.Model_Year !== null) {
        this.Filter_Global_Check.Model_Year.push(CCP.Model_Year);
      }

      if (!this.Filter_Global_Check.Status.includes(CCP.Status) && CCP.Status !== null) {
        this.Filter_Global_Check.Status.push(CCP.Status);
      }

      if (!this.Filter_Global_Check.Reviewer_Name.includes(CCP.Reviewer_Name) && CCP.Reviewer_Name !== null) {
        this.Filter_Global_Check.Reviewer_Name.push(CCP.Reviewer_Name);
      }

      if (!this.Filter_Global_Check.Approver_Name.includes(CCP.Approver_Name) && CCP.Approver_Name !== null) {
        this.Filter_Global_Check.Approver_Name.push(CCP.Approver_Name);
      }

      if (!this.Filter_Global_Check.Contributor_Name.includes(CCP.Contributor_Name) && CCP.Contributor_Name !== null) {
        this.Filter_Global_Check.Contributor_Name.push(CCP.Contributor_Name);
      }

    }


  }

  //-================== FUNCTION FOR ENABLE BTN NEW CCP ==================-\\
  public Enable_BtnNewCCP(): boolean {

    for (const CCP of this.All_FAF_CCP) {
      if (CCP.Directory) {
        return true;
      }
    }
    return false;
  }

  //-================== FUNCTION FOR ENABLE INPUT SEARCH CCP ==================-\\
  public Show_InputSearch(): boolean {

    if (this.Header_Routes.length > 3) {
      return true;
    }

    for (const CCP of this.All_FAF_CCP) {
      if (!CCP.Directory) {
        return true;
      }
    }
    return false;
  }

  //-================== FUNCTIONS FOR TABLE CCP ==================-\\

  // ============== FUNCTION FOR VERIFY IS NEW CCP ==============\\
  public Is_New_CCP_In_System(Date_Update: Date | null): boolean {

    const Current_Date = moment().utc();
    const Date_add = moment(Date_Update).utc().add(7, 'day');

    return (Date_add > Current_Date);

  }

  // ============== FUNCTION FOR FORMAT DATE CREATED ==============\\
  public Get_Date_Created(Date_Created: Date | null): string {
    return moment(Date_Created).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  // ============== FUNCTION FOR FORMAT DATE CREATED ==============\\
  public Get_Date_Modification(Modification: Date | null): string {
    return moment(Modification).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  // ============== FUNCTION FOR FORMAT DATE EXPIRATION ==============\\
  public Get_Date_Expiration(Expiration: Date | null): string {
    return moment(Expiration).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  // ============== FUNCTION FOR FORMAT STATUS ==============\\
  public Status_string(Status: number): string {
    switch (Status) {
      case 1: return 'Aprobada';
      case 2: return 'Pendiente';
      case 3: return 'Rechazada';
      case 4: return 'Eliminada';
      default: return '';
    }
  }

  // ============== FUNCTION FOR CLASS EXPIRATION STATUS ==============\\
  public Expiry_Status(Date_Expiration: Date | null): string {
    const Current_Date = moment().utc();

    const Date_Difference = moment(Date_Expiration, 'YYYY/MM/DD').utc();

    const Diference = Date_Difference.diff(Current_Date, 'days');

    if (Diference >= 16) {
      return 'NotExpired'
    } else if (Diference >= 0 && Diference <= 15) {
      return 'NearingExpired'
    } else if (Diference < 0) {
      return 'Expired'
    } else {
      return 'NotExpired'
    }
  }

  public CanDownload(CCP: FILE_CCP): boolean {
    const IsAdmin = this.UserService.UserRoleGeneralIn([this.RolesGeneral.AdministratorCCP, this.RolesGeneral.SuperAdministrator]);
    const HasFolderDownloadPermission = this.UserRoleIn([this.PermissionCCP.downloadVersionFlow]);
    const IsContributor = Number(this.ID_User_BD) === Number(CCP.ID_Contributor);
    const IsReviewer = Number(this.ID_User_BD) === Number(CCP.ID_Involved_User_Reviewer);
    const IsApprover = Number(this.ID_User_BD) === Number(CCP.ID_Involved_User_Approver);
    return IsAdmin || HasFolderDownloadPermission || IsContributor || IsReviewer || IsApprover || CCP.Status === 1;
  }

  // ============== FUNCTION FOR DOWNLOAD FILE IN TABLE ==============\\
  public DownloadTable(CCP: FILE_CCP): void {

    const IsAdmin = this.UserService.UserRoleGeneralIn([this.RolesGeneral.AdministratorCCP])

    if (IsAdmin || CCP.Status === 1) {
      this.DownloadFileCCP(CCP);
    } else {
      switch (Number(this.ID_User_BD)) {
        case Number(CCP.ID_Contributor): this.DownloadFileCCP(CCP); break;
        case Number(CCP.ID_Involved_User_Reviewer): this.DownloadFileCCP(CCP); break;
        case Number(CCP.ID_Involved_User_Approver): this.DownloadFileCCP(CCP); break;
        default: this.Download_Last_Version(CCP);
      }

    }

  }

  public async PreviewFile(item: any, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (item.Directory || !this.CanDownload(item)) return;

    // Guardamos el item seleccionado para que el botón de descarga del visor sepa qué descargar
    this.FCCP_Select_CM = item;

    Swal.fire({
      title: 'Cargando vista previa...',
      didOpen: () => { Swal.showLoading(); },
      allowOutsideClick: false
    });

    try {
      const res: any = await firstValueFrom(this.Service_CCP.Get_URL_DownloadCCP({ ID_CCP: item.ID, Type_D: 4, isPreview: true }));
      
      // Cerramos el loading de Swal ANTES de activar el visor
      Swal.close();

      if (!res.success) {
        throw new Error('No se pudo resolver la URL del documento.');
      }

      this.previewFileUrl = String(res.operation?.URL_Document || '').trim();
      this.previewFileName = item.Name;
      this.previewFileExtension = item.Extension;
      this.showPreview = true;
    } catch (e) {
      Swal.close();
      console.error(e);
      Swal.fire('Error', 'No se pudo cargar la vista previa', 'error');
    }
  }

  public DownloadFromPreview() {
    if (this.FCCP_Select_CM) {
      this.DownloadTable(this.FCCP_Select_CM);
    }
  }

  // ============== FUNCTION FOR DOWNLOAD FILE CCP ==============\\
  private async DownloadFileCCP(CCP: FILE_CCP): Promise<void> {

    const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
    const Progress_Bar_Table = document.getElementById('Progress-Bar-Table') as HTMLElement;
    ProgressModal.classList.add('active');

    try {

      const ResGetURLCCP: any = await firstValueFrom(this.Service_CCP.Get_URL_DownloadCCP({ ID_CCP: CCP.ID, Type_D: Download_Log_CCP.D_FILE_MANAGERC }));

      if (ResGetURLCCP.success) {

        const URL = ResGetURLCCP.operation.URL_CCP;

        this.Service_CCP.DownloadCCP(URL).subscribe((event: any) => {

          if (event.status === 404) {

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'error',
              title: '¡Error al descargar la HOE, informa a tu supervisor!'
            })

            ProgressModal.classList.remove('active');
            Progress_Bar_Table.style.width = '0%';

          }

          if (event['loaded'] && event['total']) {

            let Discharge_Rate: number = Math.round(event['loaded']) / event['total'] * 100;

            Progress_Bar_Table.style.width = Discharge_Rate + '%';

          }

          if (event['body']) {

            if (event.status === 200) {

              const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener('mouseenter', Swal.stopTimer)
                  toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
              })

              Toast.fire({
                icon: 'success',
                title: 'HOE descargada!'
              })

              ProgressModal.classList.remove('active');
              Progress_Bar_Table.style.width = '0%';

              saveAs(event['body'], CCP.Name);
            }

          }
        })
      }


    } catch (e) {

      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      })

      Toast.fire({
        icon: 'error',
        title: '¡Error al descargar la HOE, informa a tu supervisor!'
      })

      ProgressModal.classList.remove('active');
      Progress_Bar_Table.style.width = '0%';
    }
  }

  // ============== FUNCTION FOR DOWNLOAD FILE LAS VERSION  ==============\\
  private async Download_Last_Version(CCP: FILE_CCP): Promise<void> {

    let StatusText: string = '';

    if (CCP.Status === 2) {
      StatusText = 'Pendiente'
    } else if (CCP.Status === 3) {
      StatusText = 'Rechazada'
    }

    Swal.fire({
      title: `CCP ${StatusText}`,
      text: `Esta CPP tiene esta revisión ${StatusText}. Puedes descargar la última versión aprobada.`,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      showCancelButton: true,
      confirmButtonText: 'Descargar última revisión aprobada <i class="fa-solid fa-cloud-arrow-down"></i>',
    }).then(async (result) => {

      if (result.isConfirmed) {

        const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
        const Progress_Bar_Table = document.getElementById('Progress-Bar-Table') as HTMLElement;
        ProgressModal.classList.add('active');

        try {

          const ResGetLastVersion: any = await firstValueFrom(this.Service_CCP.Get_Last_Version_Approved({ ID_CCP: CCP.ID }));

          if (ResGetLastVersion.success) {

            const ResLastVersion: any = ResGetLastVersion.operation;

            if (ResLastVersion.Exist_VA) {


              const ResGetURL_LVA: any = await firstValueFrom(this.Service_CCP.Get_URL_Last_Version_DownloadCCP({ ID_CCP: ResLastVersion.CCP.ID, Type_D: Download_Log_CCP.D_LAST_VA_IN_FM }));

              const URL = ResGetURL_LVA.operation.URL_CCP;


              if (ResGetURL_LVA.success) {

                this.Service_CCP.DownloadCCP(URL).subscribe((event: any) => {

                  if (event.status === 404) {

                    const Toast = Swal.mixin({
                      toast: true,
                      position: 'top-end',
                      showConfirmButton: false,
                      timer: 3000,
                      timerProgressBar: true,
                      didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                      }
                    })

                    Toast.fire({
                      icon: 'error',
                      title: '¡Error al descargar la HOE, informa a tu supervisor!'
                    })

                    ProgressModal.classList.remove('active');
                    Progress_Bar_Table.style.width = '0%';

                  }

                  if (event['loaded'] && event['total']) {

                    let Discharge_Rate: number = Math.round(event['loaded']) / event['total'] * 100;

                    Progress_Bar_Table.style.width = Discharge_Rate + '%';
                  }

                  if (event['body']) {

                    if (event.status === 200) {

                      const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                          toast.addEventListener('mouseenter', Swal.stopTimer)
                          toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                      })

                      Toast.fire({
                        icon: 'success',
                        title: 'Ultima versión de CCP descargada!'
                      })

                      ProgressModal.classList.remove('active');
                      Progress_Bar_Table.style.width = '0%';
                      saveAs(event['body'], ResLastVersion.CCP.Name);
                    }

                  }
                })

              } else {
                throw "ERROR";
              }

            } else {

              const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener('mouseenter', Swal.stopTimer)
                  toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
              })

              Toast.fire({
                icon: 'warning',
                title: '¡No existe una última versión aprobada de la HOE !'
              })

              ProgressModal.classList.remove('active');
              Progress_Bar_Table.style.width = '0%';
            }

          }


        } catch (e) {

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar la última versión aprobada de la HOE, informa a tu supervisor!'
          })

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';
        }
      }
    })


  }


  //-================== FUNCTIONS FOR PERMISSIONS ==================-\\
  public UserRoleIn(Permissions: tpermissionFolderCCP[]): boolean {


    for (const Role of this.Permission_FMC) {
      const PermissionsFound = Permissions.find((p: tpermissionFolderCCP) => {
        return (p.toUpperCase() === Role.toUpperCase());
      })
      if (PermissionsFound) {
        return true;
      }

    }

    return false;

  }

  //-================== FUNCTIONS FOR RETURN TOTAL TASK ==================-\\
  public Total_Task(): string {
    return this.All_Task_CCP > 99 ? `99+` : `${this.All_Task_CCP}`;
  }

  //-===================== FUNCTION FOR SEE CONTRIBUTIONS =====================-\\
  public See_CCP_Contributions(): void {
    window.open(`${URLs.URLINDEX}/Dashboard/CCP/FlowMonitoringCCP`)
  }

  //-================== FUNCTION FOR SAVE REASON REJECT ==================-\\
  public SaveReject(): void {
    const IsValidForm = this.ValidationFormReject();

    if (this.FormReject.valid && IsValidForm) {

      const Reason: string = this.FormReject.controls['ReasonText'].value;

      Swal.fire({
        title: '¿Desea enviar la razón de rechazo?',
        text: `¡No podrá revertir cambios!`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, enviar!',
        cancelButtonText: 'No, cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Nuevamente ¿está seguro?',
            text: `¡Marque la casilla para confirmar el envió de la razón de rechazo!`,
            input: 'checkbox',
            inputPlaceholder: 'Enviar razón de rechazo',
            confirmButtonText: 'Continuar <i class="fa-solid fa-arrow-right"></i>',
            confirmButtonColor: this.ColorConfirm,
            cancelButtonColor: this.ColorsCancel,
            showCancelButton: true,
          }).then(async (resultRem) => {

            if (resultRem.value === 1) {

              try {

                const ResRejectAdmin: any = await firstValueFrom(this.Service_CCP.RejectCCPToAdmin({ ID_WF: this.FCCP_Select_CM.ID, Reason: Reason }));

                if (ResRejectAdmin.success) {
                  Swal.fire({
                    icon: 'success',
                    title: 'HOE rechazada',
                    confirmButtonColor: this.ColorConfirm,
                  })
                  this.ToggleModalReasonReject(false);
                  this.SeeFolder_BreadCrum(this.NumberTopL);
                }

              } catch (e) {
                Swal.fire({
                  title: 'Ocurrió un error al aprobar la tarea',
                  text: '¡Notifique este error al supervisor!',
                  icon: 'warning',
                  confirmButtonColor: this.ColorConfirm
                })
                this.ToggleModalReasonReject(false);
                this.SeeFolder_BreadCrum(this.NumberTopL);
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin confirmar',
                text: '¡Marque la casilla para enviar la razón de rechazo !',
                confirmButtonColor: this.ColorConfirm
              })
            }
          })
        }
      })
    }
  }

  //-================== FUNCTION FOR VALIDATE FORM ==================-\\
  private ValidationFormReject(): boolean {

    const IdTextAreaRejectCCP = document.getElementById('IdTextAreaRejectCCP') as HTMLTextAreaElement; IdTextAreaRejectCCP.classList.remove('Is-Invalid-Form');

    if (!this.FormReject.controls['ReasonText'].valid) {
      IdTextAreaRejectCCP.classList.add('ng-invalid'); IdTextAreaRejectCCP.classList.add('ng-touched');

      if (this.FormReject.controls['ReasonText'].value == '') {
        Swal.fire({
          title: 'Razón no valida',
          text: `¡Ingresa una razón de rechazo!`,
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })
        return false;
      } else {
        Swal.fire({
          title: 'Razón no valida',
          text: `¡La razón de rechazo es muy corta!`,
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })
        return false;
      }

    }

    return true;
  }

  //-================== FUNCTION FOR OPEN OR CLOSE MODAL REASON REJECT ==================-\\
  public ToggleModalReasonReject(CloseOrOpen: boolean): void {
    const ModalReject = document.getElementById('ModalReject') as HTMLDivElement;
    CloseOrOpen ? ModalReject.classList.add('active') : ModalReject.classList.remove('active');
  }

  //&===================== END FUNCTIONS FOR GENERAL SYSTEM =====================&\\




}
